class ProductSpecs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.#init();
  }

  #init() {
    const moreBtn = this.querySelector(".product-specs--more-button");
    if(moreBtn) {
      const lessBtn = this.querySelector(".product-specs--less-button");
      const wrapper = this.querySelector(".product-info__specs--wrapper");
      const lessHeight = wrapper.getBoundingClientRect().height;
      wrapper.style.setProperty("--less-height", `${lessHeight}px`);
      this.classList.add("loaded");
      wrapper.style.setProperty("--more-height", `${wrapper.lastElementChild.getBoundingClientRect().bottom - wrapper.getBoundingClientRect().top}px`);

      moreBtn.addEventListener("click", this.showMore.bind(this));
      lessBtn.addEventListener("click", this.showLess.bind(this));
    }
  }

  showMore() {
    this.classList.add("show-more");
  }

  showLess() {
    this.classList.remove("show-more");
  }
}

customElements.define("product-specs", ProductSpecs);

class ZoomModalTrigger extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const modal = document.querySelector("rao-zoom-modal");
    const handle = this.dataset.handle;
    const index = this.dataset.index;
    if(!this.closest("rao-zoom-modal")) {
      this.addEventListener("click", function(e) {
        modal.open(handle, index);
        e.stopPropagation();
      });
    }
  }
}

customElements.define("zoom-modal-trigger", ZoomModalTrigger);

class RAOZoomModal extends HTMLElement {
  #currentURL = new URL(window.location.href);
  #currentHandle = this.#currentURL.pathname.split("/")[this.#currentURL.pathname.split("/").length - 1];

  constructor() {
    super();
  }

  connectedCallback() {
    this.loading = this.querySelector(".zoom-modal--loading");
    this.container = this.querySelector(".zoom-modal--container");
    this.closeBtn = this.querySelector(".zoom-modal--header svg");

    this.addEventListener("click", function(e) {
      if(!this.loading.contains(e.target) && !this.container.contains(e.target)) {
        this.close();
      }
    }.bind(this));

    this.closeBtn.addEventListener("click", this.close.bind(this));
  }

  async open(handle, index) {
    if(handle == this.loadedHandle) {
      this.querySelector("rao-media-carousel").select(index);
      setTimeout(function() {
        this.#show();
      }.bind(this), 300);
    } else if(handle == this.#currentHandle) {
      let productContainer = document.querySelector(".product");
      if(!productContainer) {
        const response = await this.#getProductContent(handle);
        productContainer = response.querySelector(".product");
      }
      const productTitle = productContainer.querySelector(".product-info__title").innerText;
      const mediaContainer = productContainer.querySelector("rao-media-carousel");
      this.#loadData(productTitle, mediaContainer);
      this.querySelector("rao-media-carousel").select(index);
      this.#removeLoading()
      setTimeout(function() {
        this.#show();
      }.bind(this), 300);
      this.loadedHandle = handle;
    } else {
      this.#show();
      this.#addLoading();
      const response = await this.#getProductContent(handle);
      const productContainer = response.querySelector(".product");
      const productTitle = productContainer.querySelector(".product-info__title").innerText;
      const mediaContainer = productContainer.querySelector("rao-media-carousel");
      this.#loadData(productTitle, mediaContainer);
      this.querySelector("rao-media-carousel").select(index);
      setTimeout(function() {
        this.#removeLoading();
      }.bind(this), 300);
      this.loadedHandle = handle;
    }
  }

  close() {
    this.classList.remove("open");
  }

  #show() {
    this.classList.add("open");
  }

  #addLoading() {
    this.classList.add("loading");
    this.classList.add("animate");
    this.#show();
  }

  #removeLoading() {
    this.classList.remove("loading");
  }

  async #getProductContent(handle) {
    const productPageContent = await(await fetch(`https://www.ballonnenshop.nl/products/${handle}`, {
      method: 'GET',
      headers: {
        "Content-Type": "text/html",
        "Cache-Control": "no-cache"
      }
    })).text();

    const response = document.implementation.createHTMLDocument("asd");
    response.body.innerHTML = productPageContent;

    return response;
  }

  #loadData(title, container) {
    this.querySelector(".zoom-modal--title").innerText = title;
    this.querySelector(".zoom-modal--main").innerHTML = container.outerHTML;
  }
}

customElements.define("rao-zoom-modal", RAOZoomModal);

class RAOMediaCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.#setupVars();
  }

  #setupVars() {
    this.indexPos = this.querySelector(".rao-media__main--media.selected") ? parseInt(this.querySelector(".rao-media__main--media.selected").dataset.index) : 0;    
    this.mainMediaContainer = this.querySelector(".rao-media__main--medias");
    this.mainMedias = this.querySelectorAll(".rao-media__main--media");

    // FIX VOOR VERTICAAL SCROLLEN (Voorkomt gijzeling door swipe-scripts op grote foto's)
    if(this.mainMediaContainer) this.mainMediaContainer.style.touchAction = 'pan-y pinch-zoom';
    if(this.mainMedias) this.mainMedias.forEach(media => media.style.touchAction = 'pan-y pinch-zoom');

    this.prevButton = this.querySelector(".rao-media--prev-button");
    this.nextButton = this.querySelector(".rao-media--next-button");
    this.nextButton.addEventListener("click", this.next.bind(this));
    this.prevButton.addEventListener("click", this.prev.bind(this));

    this.thumbnailMediaContainer = this.querySelector(".rao-media__thumbnails--medias");
    if(this.thumbnailMediaContainer) {
      this.thumbnailMedias = this.querySelectorAll(".rao-media__thumbnails--media");

      for(const media of this.thumbnailMedias) {
        media.addEventListener("click", this.select.bind(this, parseInt(media.dataset.index)));
      }
    }

    const main = this.querySelector(".rao-media--main");

    let touchStart = 0;
    let touchEnd = 0;
    let prevTranslate = 0;
    let currentTranslate = 0;

    /*main.addEventListener("touchstart", function(e) {
      touchStart = e.touches[0].clientX;
      prevTranslate = -this.indexPos * this.mainMediaContainer.getBoundingClientRect().width;
    }.bind(this));

    main.addEventListener("touchmove", function(e) {
      touchEnd = e.touches[0].clientX;
      let diff = touchEnd - touchStart;
      currentTranslate = prevTranslate + diff;

      this.mainMediaContainer.style.setProperty("--transform-amount", `${currentTranslate}px`);

      e.preventDefault();
    }.bind(this));

    main.addEventListener("touchend", function(e) {
      const rawIndex = -currentTranslate / this.mainMediaContainer.getBoundingClientRect().width;
      let newIndex = Math.round(rawIndex);
      newIndex = Math.max(0, Math.min(newIndex, this.mainMedias.length - 1));
      this.select(newIndex);
      prevTranslate = -newIndex * this.mainMediaContainer.getBoundingClientRect().width;
    }.bind(this));

    main.addEventListener("touchcancel", function(e) {
      const rawIndex = -currentTranslate / this.mainMediaContainer.getBoundingClientRect().width;
      let newIndex = Math.round(rawIndex);
      newIndex = Math.max(0, Math.min(newIndex, this.mainMedias.length - 1));
      this.select(newIndex);
      prevTranslate = -newIndex * this.mainMediaContainer.getBoundingClientRect().width;
    }.bind(this));*/
  }

  select(index) {
    this.indexPos = index;
    this.mainSelect(index);
    this.thumbnailSelect(index);
  }

  mainSelect(index) {
    if(index < 0) {
      index = 0;
    } else if(index >= this.mainMedias.length) {
      index = this.mainMedias.length - 1;
    }

    if(index == 0) {
      this.prevButton.setAttribute("disabled", "");
    } else {
      this.prevButton.removeAttribute("disabled")
    }

    if(index == this.mainMedias.length - 1) {
      this.nextButton.setAttribute("disabled", "");
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    const selectedMedia = this.mainMedias[index];
    const prevSelectedMedia = this.mainMediaContainer.querySelector(".selected");

    prevSelectedMedia.classList.remove("selected");
    if(prevSelectedMedia.querySelector("video")) {
      prevSelectedMedia.querySelector("video").pause();
    }

    selectedMedia.classList.add("selected");
    this.mainMediaContainer.style.setProperty("--transform-amount", `${-1 * parseInt(selectedMedia.dataset.index) * 100}%`);

    if(selectedMedia.querySelector("video")) {
      selectedMedia.querySelector("video").play();
    }

    //this.mainMediaContainer.style.setProperty("--height-amount", `${selectedMedia.getBoundingClientRect().height}px`);
  }

  thumbnailSelect(index) {
    if(this.thumbnailMediaContainer) {
      if(index < 0) {
        index = 0;
      } else if(index >= this.thumbnailMedias.length) {
        index = this.thumbnailMedias.length - 1;
      }

      this.thumbnailMediaContainer.querySelector(".selected").classList.remove("selected");
      const selectedMedia = this.thumbnailMedias[index];

      selectedMedia.classList.add("selected");

      const gap = this.thumbnailMedias[1] ? this.thumbnailMedias[1].getBoundingClientRect().left - this.thumbnailMedias[0].getBoundingClientRect().right : 0;
      const itemWidth = this.thumbnailMedias[0].offsetWidth;
      const viewportWidth = this.thumbnailMediaContainer.offsetWidth;
      const totalItems = this.thumbnailMedias.length;
      const trackWidth = this.thumbnailMedias[this.thumbnailMedias.length - 1].getBoundingClientRect().right - this.thumbnailMedias[0].getBoundingClientRect().left;

      let desiredOffset = -(itemWidth * index + (index * gap)  - viewportWidth / 2 + itemWidth / 2);

      const maxOffset = 0;
      const minOffset = -(trackWidth - viewportWidth);

      let finalOffset = Math.min(maxOffset, Math.max(minOffset, desiredOffset));
      this.thumbnailMediaContainer.style.setProperty("--transform-amount", `${finalOffset}px`);
    }
  }

  next() {
    if(this.indexPos < this.mainMedias.length - 1) {
      this.indexPos++;
    }

    this.mainSelect(this.indexPos);
    this.thumbnailSelect(this.indexPos);
  }

  prev() {
    if(this.indexPos > 0) {
      this.indexPos--;
    }

    this.mainSelect(this.indexPos);
    this.thumbnailSelect(this.indexPos);
  }
}

customElements.define("rao-media-carousel", RAOMediaCarousel);

class VerticalArticles extends HTMLElement {
  constructor() {
    super();

    this.pos = 0;
    this.plus = 0;
  }

  connectedCallback() {
    this.content = this.querySelector(".vertical-articles--content");
    this.inner = this.querySelector(".vertical-articles--inner");
    this.upButton = this.querySelector(".vertical-articles--up-button");
    this.downButton = this.querySelector(".vertical-articles--down-button");
    this.articles = this.querySelectorAll(".rao-blog__all--article");

    if(window.innerWidth < 700) {
      this.plus = 4;
    } else {
      this.plus = 4;
    }

    window.addEventListener("resize", function() {
      if(window.innerWidth < 700) {
        this.plus = 4;
      } else {
        this.plus = 4;
      }
    });

    this.init();
  }

  init() {
    if(window.innerWidth < 700) {
      this.content.style.setProperty("--inner-height", `${this.getHeight(this.articles[this.pos + this.plus])}px`);
    } else {
      this.content.style.setProperty("--inner-height", `${this.getHeight(this.articles[this.pos + this.plus])}px`);
    }

    this.upButton.addEventListener("click", this.moveUp.bind(this));
    this.downButton.addEventListener("click", this.moveDown.bind(this));
  }

  moveDown() {
    if(this.pos != this.articles.length - 1 - this.plus) {
      this.pos += this.plus;

      if(this.pos == this.articles.length - 1 - this.plus) {
        this.content.style.setProperty("--inner-height", `${this.articles[this.pos + this.plus].getBoundingClientRect().bottom - this.content.getBoundingClientRect().top}px`);
      } else {
        this.content.style.setProperty("--inner-height", `${this.getHeight(this.articles[this.pos + this.plus])}px`);
      }

      if(this.pos == this.articles.length - 1 - this.plus) {
        this.downButton.classList.add("disabled");
      }

      this.upButton.classList.remove("disabled");
    }
  }

  moveUp() {
    if(this.pos != 0) {
      this.pos -= this.plus;
      this.content.style.setProperty("--inner-height", `${this.getHeight(this.articles[this.pos + this.plus])}px`);

      if(this.pos == 0) {
        this.upButton.classList.add("disabled");
      }

      this.downButton.classList.remove("disabled");
    }
  }

  getHeight(element) {
    return element.getBoundingClientRect().bottom - element.getBoundingClientRect().height / 2 - this.content.getBoundingClientRect().top
  }
}

customElements.define("vertical-articles", VerticalArticles);

class ContactButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", this.show.bind(this));
  }

  show() {
    const overlayContainer = document.querySelector("rao-tooltip-container");
    overlayContainer.show(this.querySelector(".horizontal-contact--popup-content").outerHTML); 
  }
}

customElements.define("contact-button", ContactButton);

class KlantenservicePage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sections = document.querySelectorAll(".shopify-section:not(.shopify-section-group-header-group):not(.shopify-section-group-overlay-group):not(.shopify-section-group-footer-group)");
    for(const section of sections) {
      if(!section.querySelector("klantenservice-page")) {
        const clonedSection = section.cloneNode(true);
        section.remove();
        this.appendChild(clonedSection);
      }
    }
  }
}

customElements.define("klantenservice-page", KlantenservicePage);

class HorizontalArticles extends HTMLElement {
  #readMoreBtn = null;
  #showAmount = 5;
  #articles = null;
  #articleContainer = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this.#articleContainer = this.querySelector(".horizontal-articles--articles");
    this.#articles = this.querySelectorAll(".horizontal-articles--article");

    if(this.#articles.length > 5) {
      this.#articleContainer.style.setProperty("--height", `${this.#articles[4].getBoundingClientRect().bottom - this.#articleContainer.getBoundingClientRect().top}px`);
      this.classList.add("remove-hide");
    }

    this.#readMoreBtn = this.querySelector(".horizontal-articles--read-more");
    if(this.#readMoreBtn) {
      this.#readMoreBtn.addEventListener("click", this.showMore.bind(this));
    }
  }

  showMore() {
    this.#showAmount += 5;
    if(this.#articles.length > this.#showAmount) {
      this.#articleContainer.style.setProperty("--height", `${this.#articles[this.#showAmount - 1].getBoundingClientRect().bottom - this.#articleContainer.getBoundingClientRect().top}px`);
    } else {
      this.#articleContainer.style.setProperty("--height", `${this.#articles[this.#articles.length - 1].getBoundingClientRect().bottom - this.#articleContainer.getBoundingClientRect().top}px`);
      this.#readMoreBtn.closest(".horizontal-articles--read-more-container").style.display = "none";
    }
  }
}

customElements.define("horizontal-articles", HorizontalArticles);

class RAOFAQ extends HTMLElement {
  #buttons = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this.#buttons = this.querySelectorAll(".rao-faq__accordion--button");

    for(const button of this.#buttons) {
      button.addEventListener("click", this.#clickHandle.bind(this, button));
    }
  }

  #clickHandle(button) {
    const parent = button.closest(".rao-faq--accordion");

    /*if(parent.classList.contains("selected")) {
      this.querySelector(".rao-faq--accordion.selected").classList.remove("selected");
      this.querySelector(".rao-faq--content.selected").classList.remove("selected");
      return
    }*/

    if(this.querySelector(".rao-faq--accordion.selected")) {
      this.querySelector(".rao-faq--accordion.selected").classList.remove("selected");
    }
    
    if(this.querySelector(".rao-faq--content.selected")) {
      this.querySelector(".rao-faq--content.selected").classList.remove("selected");
    }
    
    const accordionContent = parent.querySelector(".rao-faq__accordion--content");
    const accordionInner = accordionContent.querySelector(".rao-faq__accordion--inner");
    const content = this.querySelector(`.rao-faq--content[data-id="${parent.dataset.id}"]`);

    accordionContent.style.setProperty("--inner-height", `${accordionInner.getBoundingClientRect().height}px`);
    content.classList.add("selected");
    parent.classList.add("selected");
    parent.classList.toggle("open");
  }
}

customElements.define("rao-faq", RAOFAQ);

class ReviewsLoader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if(document.querySelector("#global-reviews")) {
      this.closest("section").innerHTML = document.querySelector("#global-reviews").innerHTML.replaceAll("placeholder-scroll-id", `scroll-area-${this.closest("section").id}`);
    }
  }
}

customElements.define("reviews-loader", ReviewsLoader);

class RAOAddonAnchor extends HTMLElement {
  constructor() {
    super();
  }

  parse(content) {
    const clonedAnnouncementBar = document.querySelector(".shopify-section--announcement-bar").cloneNode(true);
    clonedAnnouncementBar.querySelector(".announcement-bar--height-observer").style.setProperty("--background-color", "#f2f8ff");
    clonedAnnouncementBar.querySelector(".announcement-bar--height-observer").classList.add("overwrite");
    this.innerHTML = clonedAnnouncementBar.outerHTML + content;
    this.show();
    this.parentElement.classList.add("anchor-open");
  }

  show() {
    this.setPadding();
    document.documentElement.classList.add('lock');
    this.classList.add("active");
  }

  setPadding() {
    if(document.querySelector(".header--bottom")) {
      document.querySelector(".header--bottom").remove();
    }
  }
}

customElements.define("rao-addon-anchor", RAOAddonAnchor);

const BallonnenshopConfiguratorAnalyticsNoop = Object.freeze({
  clearRun: () => {},
  createUuid: () => null,
  emit: () => null,
  emitProductView: () => null,
  ensureRun: () => null,
  readRun: () => null,
  startRun: () => null
});

const getBallonnenshopConfiguratorAnalytics = () =>
  window.BallonnenshopConfiguratorAnalytics || BallonnenshopConfiguratorAnalyticsNoop;

const RAO_CONFIGURATOR_RETURN_STORAGE_KEY = "rao:configurator-return";
const RAO_CONFIGURATOR_RETURN_MAX_AGE = 30 * 60 * 1000;

const removeRaoConfiguratorReturnState = () => {
  try {
    window.sessionStorage.removeItem(RAO_CONFIGURATOR_RETURN_STORAGE_KEY);
  } catch (_) {}
};

const readRaoConfiguratorReturnState = () => {
  let state;
  try {
    state = JSON.parse(window.sessionStorage.getItem(RAO_CONFIGURATOR_RETURN_STORAGE_KEY) || "null");
  } catch (_) {
    removeRaoConfiguratorReturnState();
    return null;
  }

  const age = Date.now() - Number(state?.createdAt);
  if (!state ||
      state.version !== 1 ||
      state.path !== window.location.pathname ||
      !Number.isFinite(age) ||
      age < -60000 ||
      age > RAO_CONFIGURATOR_RETURN_MAX_AGE) {
    removeRaoConfiguratorReturnState();
    return null;
  }

  return state;
};


class RAOAddonTrigger extends HTMLElement {
  constructor() {
    super();
    this.productId = parseInt(this.dataset.id);
    this.catalogProductId = this.dataset.productId;
    this.filled = false;
    this.addToCart = this.dataset.addToCart;
    this.analyticsLoading = false;
    this.heliumTankUpsell = this.dataset.heliumTankUpsell == "true";
    if(this.dataset.filled == "true") {
      this.filled = true;
    }

    if (this.filled && this.addToCart === "true" && this.catalogProductId) {
      getBallonnenshopConfiguratorAnalytics().emitProductView({
        productId: this.catalogProductId,
        variantId: this.productId
      });
    }

    this.addEventListener("click", (e) => this.#clickHandle(e));
  }

  async #clickHandle(e) {
    e.preventDefault();

    if (this.analyticsLoading) return;

    this.startAnimation();

    if(this.addToCart == "true") {
      if(this.heliumTankUpsell) {
        const data = {id: this.productId, quantity: 1};
        await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data)
        });

        this.#goToHeliumTankUpsell();
        return;
      } else if(this.filled) {
        this.analyticsLoading = true;
        const analytics = getBallonnenshopConfiguratorAnalytics();
        const run = analytics.ensureRun({ productId: this.catalogProductId, variantId: this.productId });
        if (run) analytics.emit("configurator_cta_click");
        try {
          const content = await this.#getAddonContent();
          const anchor = document.querySelector("rao-addon-anchor");
          if (!anchor) {
            const anchorError = new Error("wizard_anchor_missing");
            anchorError.analyticsType = "invalid_dom";
            throw anchorError;
          }
          anchor.parse(content);
        } catch (error) {
          const errorType = ["http", "network", "invalid_response", "invalid_dom"].includes(error?.analyticsType)
            ? error.analyticsType
            : "network";
          analytics.emit("configurator_error", {
            error_stage: "wizard_load",
            error_type: errorType,
            ...(Number.isInteger(error?.httpStatus) ? { http_status: error.httpStatus } : {})
          });
        } finally {
          this.analyticsLoading = false;
          this.stopAnimation();
        }
        return;
      } else {
        const data = {id: this.productId, quantity: 1};
        await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data)
        });

        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("variant:add"));
      }
      this.stopAnimation();
    } else {
      window.location.href = this.dataset.url;
    }
  }

  startAnimation() {
    this.classList.add("animate");
  }

  stopAnimation() {
    this.classList.remove("animate");
  }

  async #getAddonContent() {
    const url = this.dataset.url;

    let fetchResponse;
    try {
      fetchResponse = await fetch(`https://www.ballonnenshop.nl${url}?view=extra-product-helper`, {
        method: 'GET',
        headers: {
          "Content-Type": "text/html",
          "Cache-Control": "no-cache"
        }
      });
    } catch (_) {
      const networkError = new Error("wizard_network_error");
      networkError.analyticsType = "network";
      throw networkError;
    }
    if (!fetchResponse.ok) {
      const httpError = new Error("wizard_http_error");
      httpError.analyticsType = "http";
      httpError.httpStatus = fetchResponse.status;
      throw httpError;
    }
    const productPageContent = await fetchResponse.text();

    const response = document.implementation.createHTMLDocument("asd");
    response.body.innerHTML = productPageContent;

    const sections = response.querySelectorAll(".shopify-section:not(.shopify-section-group-header-group):not(.shopify-section-group-overlay-group):not(.shopify-section-group-footer-group)");
    if (sections.length === 0) {
      const responseError = new Error("wizard_sections_missing");
      responseError.analyticsType = "invalid_response";
      throw responseError;
    }
    let returnHTML = "";
    for(const section of sections) {
      if(!section.classList.contains("shopify-section-group-footer-group")) {
        returnHTML += section.outerHTML;
      }
    }

    return returnHTML;
  }

  #goToHeliumTankUpsell() {
    const root = window.Shopify?.routes?.root || "/";
    window.location.href = `${root}cart?view=helium-tank-upsell`;
  }
}

customElements.define("rao-addon-trigger", RAOAddonTrigger);

class RAOTooltip extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.button = this.querySelector(".rao-tooltip--button");
    this.content = this.querySelector(".rao-tooltip--content");

    if(this.button && this.content) {
      this.button.addEventListener("click", this.open.bind(this));
    }
  }

  open() {
    document.querySelector("rao-tooltip-container").show(this.content.innerHTML);
  }
}

customElements.define("rao-tooltip", RAOTooltip);

class RAOTooltipContainer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const overlay = this.querySelector(".rao-tooltip--overlay");
    const closeBtn = this.querySelector(".rao-tooltip--close-button");

    overlay.addEventListener("click", this.hide.bind(this));
    closeBtn.addEventListener("click", this.hide.bind(this));
  }

  hide() {
    this.classList.remove("open");
  }

  show(content) {
    const inner = this.querySelector(".rao-tooltip--inner");
    inner.innerHTML = content;
    this.classList.add("open");
  }
}

customElements.define("rao-tooltip-container", RAOTooltipContainer);

class RAOAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.content = this.querySelector(".rao-accordion-content__accordion-block--content");
    this.inner = this.querySelector(".rao-accordion-content__accordion-block--inner");
    const button = this.querySelector(".rao-accordion-content__accordion-block--button");

    button.addEventListener("click", this.toggle.bind(this));
  }

  toggle() {
    this.content.style.setProperty("--inner-height", this.inner.getBoundingClientRect().height + "px");
    this.classList.toggle("open");
  }
}

customElements.define("rao-accordion", RAOAccordion);

class RAOPageReadMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const description = this.querySelector(".rao-page--description");
    const lastChild = description.lastElementChild;
    lastChild.innerHTML = lastChild.innerHTML + `<span class="page-read-more--read-less">Lees minder</span>`;

    const readLess = lastChild.querySelector(".page-read-more--read-less");
    readLess.addEventListener("click", function() {
      this.classList.remove("open");
    }.bind(this));

    const readMore = this.querySelector(".page-read-more--read-more");
    readMore.addEventListener("click", function() {
      description.style.setProperty("--full-height", `${lastChild.getBoundingClientRect().bottom - description.getBoundingClientRect().top}px`);
      this.classList.add("open");
    }.bind(this));

    if(lastChild.getBoundingClientRect().bottom != description.getBoundingClientRect().bottom) {
      this.classList.add("active");
    } else {
      this.classList.remove("active");
    }
  }
}

customElements.define("rao-page-read-more", RAOPageReadMore);

class RAOCategory extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const navItems = this.querySelectorAll(".rao-category__nav--item");

    const containers = [];

    for(const navItem of navItems) {
      containers.push(this.querySelector(`#${navItem.dataset.id}`).closest(`div:not(#${navItem.dataset.id})`));
      navItem.addEventListener("click", function() {
        if(this.querySelector(".rao-category__nav--item.active")) {
          this.querySelector(".rao-category__nav--item.active").classList.remove("active");
        }
        navItem.classList.add("active");
        const selectedElement = this.querySelector(`#${navItem.dataset.id}`);
        selectedElement.scrollIntoView({behavior: "smooth"});
      }.bind(this));
    }

    let prevScroll = window.scrollY;
    window.addEventListener("scroll", function() {
      for(let i = 0; i < containers.length; i++) {
        if(window.scrollY > prevScroll) {
          if(containers[i].getBoundingClientRect().top <= window.innerHeight / 2 && containers[i].getBoundingClientRect().top > 0) {
            if(this.querySelector(".rao-category__nav--item.active")) {
              this.querySelector(".rao-category__nav--item.active").classList.remove("active");
            }
            navItems[i].classList.add("active");
            break;
          }
        } else {
          if(containers[i].getBoundingClientRect().bottom >= window.innerHeight / 2 && containers[i].getBoundingClientRect().bottom < window.innerHeight) {
            if(this.querySelector(".rao-category__nav--item.active")) {
              this.querySelector(".rao-category__nav--item.active").classList.remove("active");
            }
            navItems[i].classList.add("active");
            break;
          }
        }
      }

      prevScroll = window.scrollY;
    }.bind(this));

    const buttons = this.querySelectorAll(".rao-category__category-pages--block");

    for(const button of buttons) {
      button.addEventListener("click", function() {
        const selectedBtn = this.querySelector(".rao-category__category-pages--block.selected");
        const selectedCategory = this.querySelector(".rao-category--sub-categories.selected");

        if(selectedBtn) {
          selectedBtn.classList.remove("selected");
          button.classList.add("selected");
        }

        if(selectedCategory) {
          selectedCategory.classList.remove("selected");
          this.querySelector(`.rao-category--sub-categories[data-index="${button.dataset.index}"]`).classList.add("selected");
        }
      }.bind(this));
    }
  }
}

customElements.define("rao-category", RAOCategory);

class RAOCategoryCollections extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const readMoreContainer = this.querySelector(".rao-category-collections__read-more--container");
    const container = this.querySelector(".rao-category--collections-container");
    const readMoreBtn = this.querySelector(".rao-category-collections__read-more--more");
    const readLessBtn = this.querySelector(".rao-category-collections__read-more--less");
    const items = this.querySelectorAll(".rao-category--collection");
    const lastItem = items[items.length - 1];

    if(window.innerWidth > 999) {
      if(!readMoreContainer.classList.contains("rao-category-collections__read-more--container-hide-desktop")) {
        container.style.setProperty("--small-height", `${items[11].getBoundingClientRect().bottom - container.getBoundingClientRect().top}px`);
      }
    } else if(window.innerWidth > 699) {
      if(!readMoreContainer.classList.contains("rao-category-collections__read-more--container-hide-tablet")) {
        container.style.setProperty("--small-height", `${items[7].getBoundingClientRect().bottom - container.getBoundingClientRect().top}px`);
      }
    } else {
      if(!readMoreContainer.classList.contains("rao-category-collections__read-more--container-hide-mobile")) {
        container.style.setProperty("--small-height", `${items[3].getBoundingClientRect().bottom - container.getBoundingClientRect().top}px`);
      }
    }

    readMoreBtn.addEventListener("click", function() {
      container.style.setProperty("--full-height", `${items[items.length - 1].getBoundingClientRect().bottom - container.getBoundingClientRect().top}px`);
      this.classList.add("open");
    }.bind(this));

    readLessBtn.addEventListener("click", function() {
      if(window.innerWidth > 999) {
        if(!readMoreContainer.classList.contains("rao-category-collections__read-more--container-hide-desktop")) {
          container.style.setProperty("--small-height", `${items[11].getBoundingClientRect().bottom - container.getBoundingClientRect().top}px`);
        }
      } else if(window.innerWidth > 699) {
        if(!readMoreContainer.classList.contains("rao-category-collections__read-more--container-hide-tablet")) {
          container.style.setProperty("--small-height", `${items[7].getBoundingClientRect().bottom - container.getBoundingClientRect().top}px`);
        }
      } else {
        if(!readMoreContainer.classList.contains("rao-category-collections__read-more--container-hide-mobile")) {
          container.style.setProperty("--small-height", `${items[3].getBoundingClientRect().bottom - container.getBoundingClientRect().top}px`);
        }
      }      
      this.classList.remove("open");
      setTimeout(function() {
        this.scrollIntoView({behavior: "smooth", block: "start"})
      }.bind(this), 300);
    }.bind(this));
  }
}

customElements.define("rao-category-collections", RAOCategoryCollections);

class CardDrawerButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", function() {
      document.querySelector("card-drawer").openCardDrawer(this.dataset.id, this.dataset.content, this.dataset.image, this.dataset.title);
    }.bind(this));
  }
}

customElements.define("card-drawer-button", CardDrawerButton);

class RAOHorizontalProduct extends HTMLElement {
  constructor() {
    super();

    document.addEventListener("cart:change", (e) => this.hideProduct(e));
  }

  connectedCallback() {
    const quickBuyBtn = this.querySelector(".horizontal-product--quick-buy .button");
    quickBuyBtn.addEventListener("click", this.addProductToCart.bind(this));
  }

  async addProductToCart() {
    const data = {id: this.dataset.id, quantity: 1};

    await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data)
    });

    if(this.dataset.heliumTankUpsell == "true") {
      const root = window.Shopify?.routes?.root || "/";
      window.location.href = `${root}cart?view=helium-tank-upsell`;
      return;
    }

    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("variant:add"));
  }

  hideProduct(e) {
    for(const product of e.detail.cart.items) {
      if(product.id == parseInt(this.dataset.id)) {
        this.classList.add("hide");
        return
      }
    }

    this.classList.remove("hide");
  }
}

customElements.define("rao-horizontal-product", RAOHorizontalProduct);

class RAOSEO extends HTMLElement {
  constructor() {
    super();

    const readMoreContainer = this.querySelector(".rao-seo--read-more-container");
    if(readMoreContainer) {
      this.container = this.querySelector(".rao-seo--container");
      this.content = this.querySelector(".rao-seo--content");
      this.desktopMoreContent = this.querySelector(".rao-seo--more-content-desktop");
      this.mobileMoreContent = this.querySelector(".rao-seo--more-content-mobile");
      
      const readMore = readMoreContainer.querySelector(".rao-seo__read-more-button--more");
      const readLess = readMoreContainer.querySelector(".rao-seo__read-more-button--less");

      readMore.addEventListener("click", this.show.bind(this));
      readLess.addEventListener("click", this.hide.bind(this));
    }
  }

  connectedCallback() {
    /*window.addEventListener("resize", function() {
      this.classList.remove("show", "show-more");
    }.bind(this));*/
  }

  show() {
    if(window.innerWidth < 700) {
      this.container.style.setProperty("--default-height", `${this.container.getBoundingClientRect().height}px`);
      this.classList.add("show");
      this.container.style.setProperty("--more-height", `${this.container.getBoundingClientRect().height + this.mobileMoreContent.getBoundingClientRect().height}px`);
      this.classList.add("show-more");
    } else {
      this.content.style.setProperty("--default-height", `${this.content.getBoundingClientRect().height}px`);
      this.classList.add("show");
      this.content.style.setProperty("--more-height", `${this.content.getBoundingClientRect().height + this.desktopMoreContent.getBoundingClientRect().height}px`);
      this.classList.add("show-more");
    }
  }

  hide() {
    this.classList.remove("show-more");
  }
}

customElements.define("rao-seo", RAOSEO);

class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector(".read-more--content");
    this.inner = this.querySelector(".read-more--inner");
    this.moreBtn = this.querySelector(".read-more--more");
    this.lessBtn = this.querySelector(".read-more--less");

    this.moreBtn.addEventListener("click", this.show.bind(this));
    this.lessBtn.addEventListener("click", this.hide.bind(this));
  }

  connectedCallback() {
    if(document.readyState == "complete") {
      if(this.content.getBoundingClientRect().height < this.inner.getBoundingClientRect().height) {
        this.classList.add("show");
      }
    } else {
      window.addEventListener("load", function() {
        if(this.content.getBoundingClientRect().height < this.inner.getBoundingClientRect().height) {
          this.classList.add("show");
        }
      }.bind(this));
    }
  }

  show() {
    this.content.style.setProperty("--inner-height", `${this.inner.getBoundingClientRect().height}px`);
    this.classList.add("show-more");
  }

  hide() {
    this.classList.remove("show-more");
  }
}

customElements.define("read-more", ReadMore);

class FeaturedCollections extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const btns = this.querySelectorAll(".featured-collections__collection-bar--collection");
    for(const btn of btns) {
      btn.addEventListener("click", function() {
        this.querySelector(".featured-collections__collection-bar--collection.selected").classList.remove("selected");
        btn.classList.add("selected");
        this.querySelector(".featured-collections--floating-controls.selected").classList.remove("selected");
        this.querySelector(`.featured-collections--floating-controls[data-id="${btn.dataset.id}"]`).classList.add("selected");
      }.bind(this));
    }
  }
}

customElements.define("featured-collections", FeaturedCollections);

class ASDTooltip extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const shippingBlock = this.querySelector(".product-info--shipping-block");
    if(shippingBlock) {
      const btn = shippingBlock.querySelector(".tooltip-btn svg");
      const tooltip = shippingBlock.querySelector(".product-info--shipping-block--tooltip");
      const headerHeight = document.querySelector('header').getBoundingClientRect().height + document.querySelector('.shopify-section--announcement-bar').getBoundingClientRect().height;
  
      btn.addEventListener("click", function() {
        tooltip.classList.toggle("show");
      });
  
      window.addEventListener('click', function(e) {
        if(tooltip.classList.contains('show')) {
          if(!(tooltip.contains(e.target)) && !(btn.contains(e.target))) {
            tooltip.classList.remove('show');
          }
        }
      });
  
      window.addEventListener("scroll", function() {
        if(!tooltip.classList.contains("show")) {
          if(tooltip.getBoundingClientRect().top - headerHeight < tooltip.getBoundingClientRect().height) {
            tooltip.classList.add('bottom');
          } else {
            tooltip.classList.remove('bottom');
          }
        }
      });
  
      if(tooltip.getBoundingClientRect().top - headerHeight < tooltip.getBoundingClientRect().height) {
        tooltip.classList.add('bottom');
      } else {
        tooltip.classList.remove('bottom');
      }
    }
  }
}

customElements.define("asd-tooltip", ASDTooltip);

class ReedMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.container = this.querySelector('.reed-more--content-container');
    this.content = this.querySelector('.reed-more--content');
    this.toggleBtn = this.querySelector('.toggle-btn');

    this.isExpanded = false;
    this.collapsedHeight = 0;
    this.expandedHeight = 0;
    this.settings = {
      desktopLines: this.getAttribute('line-amount') || 1,
      mobileLines: this.getAttribute('line-amount-mobile') || 1,
      showMoreText: this.getAttribute('show-more-text'),
      showLessText: this.getAttribute('show-less-text')
    };

    window.addEventListener('resize', () => this.toggle(this));

    this.toggleBtn.addEventListener('click', () => {
      this.toggle(this);
    });

    this.update(this);
  }

  toggle(context) {
    context.isExpanded = !context.isExpanded;
    context.content.style.maxHeight = context.isExpanded ? this.expandedHeight + 'px' : context.collapsedHeight + 'px';
    context.toggleBtn.textContent = context.isExpanded ? context.settings.showLessText : context.settings.showMoreText;
    context.update(context);
  }

  update(context) {
    const lineHeight = parseFloat(getComputedStyle(context.content).lineHeight);
    const maxLines = window.innerWidth <= 999 ? context.settings.mobileLines : context.settings.desktopLines;

    if (window.innerWidth <= 999) {
      const toggleBtn = context.content.children[context.settings.desktopLines - 1].querySelector(".toggle-btn-container");
      context.container.setAttribute("style", `--line-amount: ${context.settings.mobileLines}`);
      if (toggleBtn) {
        toggleBtn.remove();
      }
    } else {
      const toggleBtn = context.content.children[context.settings.mobileLines - 1].querySelector(".toggle-btn-container");
      context.container.setAttribute("style", `--line-amount: ${context.settings.desktopLines}`);
      if (toggleBtn) {
        toggleBtn.remove();
      }
    }

    context.collapsedHeight = lineHeight * maxLines;
    context.expandedHeight = context.content.scrollHeight;

    if (!context.isExpanded) {
      context.content.style.maxHeight = context.collapsedHeight + 'px';
      context.container.classList.add('container-collapsed');
      setTimeout(() => {
        context.content.classList.add('collapsed');
      }, 400)
    } else {
      context.content.style.maxHeight = context.expandedHeight + 'px';
      context.container.classList.remove('container-collapsed');
      context.content.classList.remove('collapsed');
    }
  }
}

customElements.define("reed-more", ReedMore);

class RedMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const inner = this.querySelector(".red-more--inner");
    const lineAmount = this.getAttribute('line-amount') || 1;
    const style = window.getComputedStyle(inner);

    this.initEvents(inner);

    this.activeDecider(inner, lineAmount, style);
    window.addEventListener("resize", function() {
      this.activeDecider(inner, lineAmount, style);
    }.bind(this));
  }

  activeDecider(inner, lineAmount, style) {
    const lineHeight = parseFloat(style.getPropertyValue("line-height").replace("px", ""));
    if(parseFloat(inner.getBoundingClientRect().height.toFixed(2)) > parseFloat(lineHeight.toFixed(2))) {
      this.classList.add("show-buttons");
    } else {
      this.classList.remove("show-buttons");
    }

    this.classList.add("show");
  }

  initEvents(inner) {
    const content = this.querySelector(".red-more--content");
    const moreBtn = this.querySelector(".red-more--more");
    const lessBtn = this.querySelector(".red-more--less");

    moreBtn.addEventListener("click", function() {
      content.style.setProperty("--inner-height", `${inner.getBoundingClientRect().height}px`);
      this.classList.add("open");
    }.bind(this));

    lessBtn.addEventListener("click", function() {
      window.scrollTo({top: 0, behavior: "smooth"});
      this.classList.remove("open");
    }.bind(this));
  }
}

customElements.define("red-more", RedMore);

class TotalCalculator extends HTMLElement {
  constructor() {
    super();
    this.cartAmount = parseFloat(this.dataset.currentAmount);
  }

  increase(amount) {
    this.cartAmount += parseFloat(amount);
    this.recalculate();
  }

  decrease(amount) {
    this.cartAmount -= parseFloat(amount);
    this.recalculate();
  }

  recalculate() {
    this.innerText = `€ ${(this.cartAmount / 100).toFixed(2).replace(".", ",")}`;
    this.dataset.currentAmount = this.cartAmount;
  }
}

customElements.define("total-calculator", TotalCalculator);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();
    this.freeAmount = parseFloat(this.dataset.freeAmount);
    this.cartAmount = parseFloat(this.dataset.cartAmount);
    this.freeText = this.dataset.freeText;
    this.notFreeShippingAmount = parseFloat(this.dataset.notFreeShipping);
  }

  increase(amount) {
    this.cartAmount += parseFloat(amount);
    this.recalculate();
  }

  decrease(amount) {
    this.cartAmount -= parseFloat(amount);
    this.recalculate();
  }

  recalculate() {
    this.dataset.cartAmount = this.cartAmount;
    if(this.cartAmount >= this.freeAmount) {
      this.innerText = this.freeText;
      this.dataset.currentAmount = "0";
    } else {
      this.innerText = `€ ${(this.notFreeShippingAmount / 100).toFixed(2).replace(".", ",")}`;
      this.dataset.currentAmount = (this.notFreeShippingAmount / 100).toFixed(2);
    }
  }
}

customElements.define("shipping-calculator", ShippingCalculator);

class AddonSection extends HTMLElement {
  constructor() {
    super();
    this.cart = this.querySelector(".addon-section--cart");
    this.totalCalculator = this.querySelector("total-calculator");
    this.tabs = this.querySelectorAll(".addon-section--tab");
    const restoredState = window.__raoConfiguratorRestoreState || null;
    this.analytics = getBallonnenshopConfiguratorAnalytics();
    this.analytics.ensureRun({
      productId: this.dataset.productId,
      variantId: this.dataset.variantId
    });
    this.stepVisitId = null;
    this.stepStartedAt = null;
    this.completedStepVisitId = null;
    this.pendingBackSource = null;
    this.pendingSelectionTimer = null;
    this.isCartSubmitting = false;
    this.pageshowHandler = () => this.resetCartSubmitState();
    window.addEventListener("pageshow", this.pageshowHandler);
    this.deliverySelectionSource = "default";
    this.deliverySelectionHandler = (event) => {
      const sliderDate = event.target?.closest?.(".date-slider--block");
      if (sliderDate && !sliderDate.classList.contains("disabled")) {
        this.deliverySelectionSource = "slider";
        return;
      }
      const calendarDate = event.target?.closest?.("rao-date-picker .rao-date-picker--day-name");
      if (calendarDate &&
          !calendarDate.classList.contains("disabled") &&
          !calendarDate.classList.contains("no-hover")) {
        this.deliverySelectionSource = "calendar";
      }
    };
    document.addEventListener("click", this.deliverySelectionHandler, true);

    // WIZARD STATE
    const lastStep = Math.max(0, this.tabs.length - 1);
    const restoredStep = Number.isInteger(restoredState?.step)
      ? Math.min(lastStep, Math.max(0, restoredState.step))
      : 0;
    this.currentStep = restoredStep;
    this.isTextStepActive = restoredStep === 0 && restoredState?.textActive === true;
    if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

    // =========================================
    // HISTORY API MAGIC (BROWSER TERUG KNOP FIX)
    // =========================================
    if (restoredState) {
      // Browser-terug heeft deze wizard-state al geselecteerd. Hergebruik die
      // entry, anders ontstaat er na terugkeren een extra geschiedenisstap.
      const currentHistoryState = window.history.state && typeof window.history.state === "object"
        ? window.history.state
        : {};
      window.history.replaceState({
        ...currentHistoryState,
        step: this.currentStep,
        textActive: this.isTextStepActive
      }, '');
    } else {
      // 1. We leggen een onzichtbaar 'vangnet' neer voor de browser-terug knop
      window.history.replaceState({ isPDPFallback: true }, '');
      
      // 2. Daarna starten we de wizard pas als een 'nieuwe' pagina erbovenop
      window.history.pushState({ step: 0, textActive: false }, '');
    }
    
    // Luister naar de fysieke BROWSER terug- (of vooruit) knop
    this.popstateHandler = (e) => {
        this.clearPendingSelection();
        if (e.state && typeof e.state.step !== 'undefined') {
            // We navigeren netjes een stapje terug BINNEN de wizard
            const previousStep = this.getStepDescriptor();
            const nextStep = this.getStepDescriptor(e.state.step, e.state.textActive);
            if (nextStep.position < previousStep.position) {
              this.analytics.emit("configurator_back", {
                from_step_id: previousStep.id,
                to_step_id: nextStep.id,
                interaction_source: this.pendingBackSource || "browser"
              });
            }
            this.pendingBackSource = null;
            this.currentStep = e.state.step;
            this.isTextStepActive = e.state.textActive;
            this.updateWizardUI();
            this.emitStepView();
            this.scrollWizardToTop();
        } else if (e.state && e.state.isPDPFallback) {
            // BOEM! Ze drukken op de browser-terug knop terwijl ze bij stap 1 zijn.
            // In plaats van terug naar de collectie te vallen, grijpen we in 
            // en herladen we de schone productpagina (PDP).
            const previousStep = this.getStepDescriptor();
            this.analytics.emit("configurator_back", {
              from_step_id: previousStep.id,
              to_step_id: "product_page",
              interaction_source: this.pendingBackSource || "browser"
            });
            window.location.href = window.location.pathname;
        }
    };
    window.addEventListener('popstate', this.popstateHandler);

    // Vertel de héle pagina dat de wizard actief is!
    document.body.classList.add('rao-wizard-is-active');

    // DE VEILIGE FIX: Zet de knop aan het EINDE (append) van de header, 
    // zodat PDP scripts niet in de war raken.
    try {
        const headerEl = document.querySelector('.header--top') || document.querySelector('header'); 
        if (headerEl && !document.querySelector('.global-header-terug-btn')) {
            const backBtn = document.createElement('div');
            backBtn.className = 'global-header-terug-btn';
            backBtn.innerHTML = '<svg viewBox="0 0 24 24" style="width:20px;height:20px;stroke:currentColor;stroke-width:2.5;fill:none;"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg> <span>Vorige</span>';
            
            headerEl.appendChild(backBtn);

            backBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.handleBackAction(); 
            });
        }
    } catch (e) {
        console.warn("Kon Terug-knop niet in header plaatsen:", e);
    }

    this.setupTabs();
    if (restoredState) {
      // De parent wordt bij dynamische HTML vóór sommige child custom elements
      // geüpgraded. Herstel daarom pas zodra o.a. total-calculator klaar is.
      setTimeout(() => {
        try {
          this.restoreConfiguratorState(restoredState);
        } catch (error) {
          console.warn("Kon configuratorkeuzes niet herstellen:", error);
        } finally {
          removeRaoConfiguratorReturnState();
          window.__raoConfiguratorRestoreState = null;
          window.__raoConfiguratorRestoreLoading = false;
        }
      }, 0);
    }
    this.updateWizardUI();
    this.analytics.emit("configurator_start", { selection_action: "started" });
    this.emitStepView();

    const checkoutBtn = this.querySelector(".addon-section--add-to-cart");
    if(checkoutBtn) checkoutBtn.addEventListener("click", this.addToCart.bind(this));

    this.setupWizardNavigation();
  }

  disconnectedCallback() {
    window.removeEventListener('popstate', this.popstateHandler);
    window.removeEventListener("pageshow", this.pageshowHandler);
    document.removeEventListener("click", this.deliverySelectionHandler, true);
    this.clearPendingSelection();
  }

  resetCartSubmitState() {
    this.isCartSubmitting = false;
    this.querySelector(".addon-section--add-to-cart")?.classList.remove("animate");
  }

  restoreConfiguratorState(state) {
    const selectedOptions = Array.isArray(state?.selectedOptions)
      ? state.selectedOptions.slice(0, 3)
      : [];

    for (const option of selectedOptions) {
      const index = String(option?.index ?? "");
      const variantId = String(option?.id ?? "");
      if (!["0", "1", "2"].includes(index) || !variantId) continue;

      const tab = Array.from(this.tabs).find((item) => item.dataset.index === index);
      const input = Array.from(tab?.querySelectorAll(".addon-section__tab--product input") || [])
        .find((item) => String(item.value) === variantId);
      const product = input?.closest(".addon-section__tab--product");
      if (!tab || !product) continue;

      tab.querySelectorAll(".addon-section__tab--product.selected")
        .forEach((item) => item.classList.remove("selected"));
      product.classList.add("selected");

      const note = typeof option.note === "string" ? option.note : "";
      this.addProductToCart(tab, product, note || null);

      if (index === "0") {
        const textarea = tab.querySelector("textarea");
        if (textarea) textarea.value = note;
        const previewImg = document.getElementById("id-wizard-preview-image");
        const imgSrc = product.getAttribute("data-img-src") || product.querySelector("img")?.src;
        if (previewImg && imgSrc) previewImg.src = imgSrc;
      }
    }

    const orderNote = this.querySelector('[name="note"]');
    if (orderNote && typeof state?.orderNote === "string") {
      orderNote.value = state.orderNote;
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(state?.deliveryDate || "")) {
      localStorage.setItem("date", state.deliveryDate);
      localStorage.setItem("last_chosen_date", state.deliveryDate);
    }
  }

  saveConfiguratorReturnState(deliveryDate) {
    const selectedOptions = Array.from(
      this.cart.querySelectorAll('.addon-section__cart--product:not(.addon-section__cart--product-main)[data-id]')
    ).map((cartProduct) => ({
      index: cartProduct.dataset.index,
      id: cartProduct.dataset.id,
      note: cartProduct.dataset.note || ""
    }));
    const orderNote = this.querySelector('[name="note"]');

    try {
      window.sessionStorage.setItem(RAO_CONFIGURATOR_RETURN_STORAGE_KEY, JSON.stringify({
        version: 1,
        path: window.location.pathname,
        createdAt: Date.now(),
        step: this.currentStep,
        textActive: this.isTextStepActive,
        selectedOptions,
        orderNote: orderNote?.value || "",
        deliveryDate: deliveryDate || ""
      }));
    } catch (_) {}
  }

  getStepDescriptor(step = this.currentStep, textActive = this.isTextStepActive) {
    if (step === 0 && textActive) return { id: "card_message", position: 2 };
    if (step === 0) return { id: "card_choice", position: 1 };
    if (step === 1) return { id: "weight", position: 3 };
    if (step === 2) return { id: "gift", position: 4 };
    return { id: "delivery_date", position: 5 };
  }

  getStepEventFields() {
    const step = this.getStepDescriptor();
    return {
      step_id: step.id,
      step_position: step.position,
      step_visit_id: this.stepVisitId
    };
  }

  emitStepView() {
    this.stepVisitId = this.analytics.createUuid();
    this.completedStepVisitId = null;
    this.stepStartedAt = performance.now();
    if (!this.stepVisitId) return;
    this.analytics.emit("configurator_step_view", this.getStepEventFields());
  }

  completeCurrentStep(completionType, fields = {}) {
    if (!this.stepVisitId || this.completedStepVisitId === this.stepVisitId) return false;
    this.completedStepVisitId = this.stepVisitId;
    const elapsedMs = this.stepStartedAt === null ? undefined : Math.max(0, Math.round(performance.now() - this.stepStartedAt));
    this.analytics.emit("configurator_step_complete", {
      ...this.getStepEventFields(),
      completion_type: completionType,
      ...(elapsedMs === undefined ? {} : { elapsed_ms: elapsedMs }),
      ...fields
    });
    return true;
  }

  clearPendingSelection() {
    if (this.pendingSelectionTimer) clearTimeout(this.pendingSelectionTimer);
    this.pendingSelectionTimer = null;
  }

  getOptionGroup() {
    if (this.currentStep === 0) return "card";
    if (this.currentStep === 1) return "weight";
    if (this.currentStep === 2) return "gift";
    return null;
  }


  goToStep(newStep, textActive = false) {
  this.clearPendingSelection();
  this.forceWizardTop();

  this.currentStep = newStep;
  this.isTextStepActive = textActive;

  window.history.pushState({
    step: this.currentStep,
    textActive: this.isTextStepActive
  }, '');

  this.updateWizardUI();
  this.emitStepView();

  this.forceWizardTop();
  requestAnimationFrame(() => this.forceWizardTop());
  setTimeout(() => this.forceWizardTop(), 50);
  setTimeout(() => this.forceWizardTop(), 200);
}
forceWizardTop() {
  const wizardTop =
    this.querySelector('.rao-wizard-top-bar') ||
    this.closest('.addon-section--section') ||
    this;

  const header = document.querySelector('.header--top') || document.querySelector('header');
  const headerHeight = header ? header.getBoundingClientRect().height : 0;

  const targetY = Math.max(
    0,
    wizardTop.getBoundingClientRect().top + window.pageYOffset - headerHeight
  );

  window.scrollTo(0, targetY);

  if (document.scrollingElement) {
    document.scrollingElement.scrollTop = targetY;
  }

  document.documentElement.scrollTop = targetY;
  document.body.scrollTop = targetY;

  document.querySelectorAll(
    'main, #main, .anchor, .anchor-open, rao-addon-anchor, .addon-section--anchor'
  ).forEach((el) => {
    if (el && el.scrollHeight > el.clientHeight) {
      el.scrollTop = 0;
    }
  });
}

scrollWizardToTop() {
  const topTarget = this.querySelector('.rao-wizard-top-bar') || this;

  const doScroll = () => {
    window.scrollTo(0, 0);

    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }

    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    let parent = topTarget.parentElement;
    while (parent) {
      if (parent.scrollHeight > parent.clientHeight) {
        parent.scrollTop = 0;
      }
      parent = parent.parentElement;
    }

    topTarget.scrollIntoView({
      behavior: 'auto',
      block: 'start'
    });
  };

  doScroll();
  requestAnimationFrame(doScroll);
  setTimeout(doScroll, 80);
  setTimeout(doScroll, 250);
}

  // DE CENTRALE LOGICA VOOR DE TERUG-KNOP
  handleBackAction() {
    if (this.currentStep === 0 && !this.isTextStepActive) {
      // 1. Helemaal aan het begin van de wizard! 
      // Negeer de browser-geschiedenis (die naar de collectie wijst) 
      // en forceer een terugkeer naar de schone productpagina (PDP).
      const current = this.getStepDescriptor();
      this.analytics.emit("configurator_back", {
        from_step_id: current.id,
        to_step_id: "product_page",
        interaction_source: "wizard_back"
      });
      window.location.href = window.location.pathname; 
    } else {
      // 2. Zit je dieper in de wizard? 
      // Laat de browser dan netjes één 'virtuele' stap terug doen.
      this.pendingBackSource = "wizard_back";
      window.history.back();
    }
  }

  setupWizardNavigation() {
    this.addEventListener('click', (e) => {
      
      // 1. SKIP KAART KNOP
      if (e.target.closest('.id-wizard-skip-card-btn')) {
        const step1 = this.tabs[0];
        if (step1) {
          step1.querySelectorAll(".addon-section__tab--product").forEach(p => p.classList.remove("selected"));
          const textarea = step1.querySelector("textarea");
          if(textarea) textarea.value = "";
          
          const cartProduct = this.querySelector(`.addon-section--cart .addon-section__cart--product[data-index="0"]`);
          if(cartProduct && cartProduct.dataset.price && !cartProduct.classList.contains("hidden")) {
            this.totalCalculator.decrease(parseFloat(cartProduct.dataset.price));
            cartProduct.classList.add("hidden");
            cartProduct.removeAttribute("data-id");
            cartProduct.removeAttribute("data-price");
          }
        }
        this.completeCurrentStep("skipped");
        this.goToStep(this.currentStep + 1, false);
        return; 
      }

      // 2. VOLGENDE KNOPPEN
      if (e.target.closest('.js-wizard-next-trigger') || e.target.closest('.js-wizard-next-btn')) {
        if(this.currentStep === 0 && this.isTextStepActive) {
           const textarea = this.tabs[0].querySelector('textarea');
           const hasMessage = Boolean(textarea && textarea.value.trim());
           if (textarea) this.updateProductTextOnly(this.tabs[0], textarea.value);
           this.completeCurrentStep("selected", { has_message: hasMessage });
        } else if (this.currentStep > 0 && this.currentStep < this.tabs.length - 1) {
          const selectedProduct = this.tabs[this.currentStep]?.querySelector(".addon-section__tab--product.selected");
          this.completeCurrentStep(selectedProduct ? "selected" : "skipped");
        }
        if (this.currentStep < this.tabs.length - 1) {
          this.goToStep(this.currentStep + 1, false);
        }
        return;
      }

      // 3. VORIGE KNOP BINNEN DE WIZARD
      if (e.target.closest('.id-wizard-back-btn')) { 
        this.handleBackAction();
        return;
      }

      // 4. WIJZIGEN KNOP (Tekstvak terug naar kaarten)
      if (e.target.closest('.id-wizard-change-card-btn')) {
         this.pendingBackSource = "change_card";
         window.history.back(); // Triggert automatisch een stap terug in de geschiedenis!
         return;
      }
    });
  }

  updateWizardUI() {
    // Toon de juiste tab
    this.tabs.forEach((tab, index) => {
      if (index === this.currentStep) {
        tab.style.display = 'block';
        tab.classList.add('is-active-step');
      } else {
        tab.style.display = 'none';
        tab.classList.remove('is-active-step');
      }
    });

    // Splitsing Stap 1: CSS classes toewijzen
    const step1Tab = this.tabs[0];
    if (step1Tab) {
      if (this.currentStep === 0 && this.isTextStepActive) {
        step1Tab.classList.add('wizard-state-text');
        step1Tab.classList.remove('wizard-state-cards');
      } else {
        step1Tab.classList.add('wizard-state-cards');
        step1Tab.classList.remove('wizard-state-text');
      }
    }

    // Update stappen indicator tekst in de header
    const stepNumDisplay = document.querySelector('#id-active-step-num');
    if(stepNumDisplay) stepNumDisplay.textContent = this.currentStep + 1;
    
    // Update de titel in de header
    const stepNameDisplay = document.querySelector('#id-active-step-name');
    if (stepNameDisplay) {
      if (this.currentStep === 0) {
        stepNameDisplay.textContent = this.isTextStepActive ? 'Persoonlijk bericht' : 'Kaartje';
      } else if (this.currentStep === 1) {
        stepNameDisplay.textContent = 'Gewichtje';
      } else if (this.currentStep === 2) {
        stepNameDisplay.textContent = 'Cadeautje';
      } else if (this.currentStep === 3) {
        stepNameDisplay.textContent = 'Bezorgdatum';
      }
    }

    // Update oranje voortgangsbalkjes
    const dots = document.querySelectorAll('.rao-wizard-dot');
    dots.forEach((dot, idx) => {
      if(idx <= this.currentStep) dot.classList.add('active');
      else dot.classList.remove('active');
    });

    // Update back button fallback (voor het geval je de oude ergens had gelaten)
    const backBtn = document.querySelector('.id-wizard-back-btn');
    if(backBtn) {
       if(this.currentStep === 0 && !this.isTextStepActive) backBtn.innerHTML = '&larr; Terug naar product';
       else if(this.currentStep === 0 && this.isTextStepActive) backBtn.innerHTML = '&larr; Ander kaartje kiezen';
       else backBtn.innerHTML = '&larr; Vorige stap';
    }
  }

  setupTabs() {
    for(const tab of this.tabs) {
      const content = tab.querySelector(".addon-section__tab--content");
      if(content) {
        content.style.height = 'auto';
        content.style.overflow = 'visible';
      }
      this.setupProductShowButtons(tab);
      this.handleProductSelection(tab);
    }
  }

  setupProductShowButtons(tab) {
    const showMoreContainer = tab.querySelector(".addon-section__tab--product-show-container");
    if(showMoreContainer) {
      const productsContainer = tab.querySelector(".addon-section__tab--products");
      const moreBtn = showMoreContainer.querySelector(".addon-section__tab--product-show-button-more");

      if(productsContainer) {
         // Start de check om 6 of 8 kaarten te laten zien
         this.showTabProducts(tab);
      }

      if (moreBtn) {
        // Wat gebeurt er als je op "Meer laden" klikt?
        moreBtn.addEventListener("click", () => {
           // 1. Haal de verborgen status van alle kaarten af (alles wordt zichtbaar)
           const hiddenProducts = productsContainer.querySelectorAll('.is-hidden-product');
           hiddenProducts.forEach(p => p.classList.remove('is-hidden-product'));
           
           // 2. Laat de "Meer laden" knop daarna netjes verdwijnen
           showMoreContainer.style.display = 'none';
        });
      }
    }
  }

  showTabProducts(tab) {
    const productsContainer = tab.querySelector(".addon-section__tab--products");
    if(productsContainer) {
      // Pak alleen de échte kaarten (negeer het onzichtbare stysteem-blokje)
      const realProducts = Array.from(productsContainer.querySelectorAll('.addon-section__tab--product:not(.addon-section__tab--product-empty)'));
      
      // HET MAGISCHE GETAL: 6 kaarten op mobiel, 8 op desktop
      const limit = window.innerWidth < 768 ? 6 : 8;
      
      // Loop door alle kaarten heen
      realProducts.forEach((product, index) => {
          if (index >= limit) {
              // Valt de kaart buiten het limiet? Verberg hem!
              product.classList.add('is-hidden-product');
          } else {
              // Binnen het limiet? Zorg dat hij zichtbaar is
              product.classList.remove('is-hidden-product');
          }
      });
      
      // Is de categorie eigenlijk heel klein (bijv. maar 4 kaarten)?
      // Verberg dan direct de hele "Meer laden" knop, want die is niet nodig!
      const showCont = tab.querySelector(".addon-section__tab--product-show-container");
      if(showCont) {
          if(realProducts.length <= limit) {
              showCont.style.display = "none";
          } else {
              showCont.style.display = "block";
          }
      }
    }
  }

  handleProductSelection(tab) {
    const productsContainer = tab.querySelector(".addon-section__tab--products");
    if (!productsContainer) return;
    const products = productsContainer.querySelectorAll(".addon-section__tab--product");

    for(const product of products) {
      product.addEventListener("click", (e) => {
          // Negeer zoom klik
          if(e.target.closest('.rao-zoom-btn') || e.target.closest('zoom-modal-trigger')) return;

          const variantInput = product.querySelector('input');
          const selectedVariantId = variantInput?.value;
          if (!selectedVariantId) return;
          const optionGroup = this.getOptionGroup();

          // Als dit product al geselecteerd is: NIET deselecteren, maar doorgaan
          if (product.classList.contains("selected")) {
            this.clearPendingSelection();
            this.completeCurrentStep("selected", { option_group: optionGroup, option_variant_id: selectedVariantId });
            if (this.currentStep === 0 && !this.isTextStepActive) {
              const previewImg = document.getElementById('id-wizard-preview-image');
              const imgSrc = product.getAttribute('data-img-src') || product.querySelector('img')?.src;
              if (previewImg && imgSrc) previewImg.src = imgSrc;
              this.goToStep(0, true);
            } else if (this.currentStep > 0 && this.currentStep < this.tabs.length - 1) {
              this.goToStep(this.currentStep + 1, false);
            }
            return;
          }

          // Visueel direct aanpassen
          const previouslySelected = tab.querySelector(".addon-section__tab--product.selected");
          const previousVariantId = previouslySelected?.querySelector('input')?.value;
          if(previouslySelected) {
            previouslySelected.classList.remove("selected");
            if(previousVariantId) this.removeProductFromCartById(previousVariantId);
          }
          
          product.classList.add("selected");
          this.addProductToCart(tab, product, null);
          this.analytics.emit("configurator_option_change", {
            ...this.getStepEventFields(),
            option_group: optionGroup,
            option_variant_id: selectedVariantId,
            ...(previousVariantId ? { previous_option_variant_id: previousVariantId } : {}),
            selection_action: previousVariantId ? "changed" : "selected"
          });

          // Auto-advance voor kaarten, gewichtjes en cadeautjes!
          this.clearPendingSelection();
          this.pendingSelectionTimer = setTimeout(() => {
            this.pendingSelectionTimer = null;
            this.completeCurrentStep("selected", { option_group: optionGroup, option_variant_id: selectedVariantId });
            if (this.currentStep === 0 && !this.isTextStepActive) {
              const previewImg = document.getElementById('id-wizard-preview-image');
              const imgSrc = product.getAttribute('data-img-src') || product.querySelector('img')?.src;
              if(previewImg && imgSrc) previewImg.src = imgSrc;
              this.goToStep(0, true);
            } else if (this.currentStep > 0 && this.currentStep < this.tabs.length - 1) {
              this.goToStep(this.currentStep + 1, false);
            }
          }, 400); 
      });
    }
  }

  updateProductTextOnly(tab, textValue) {
    const tabIndex = tab.dataset.index;
    const cartProductElement = this.querySelector(`.addon-section--cart .addon-section__cart--product[data-index="${tabIndex}"]`);
    if(cartProductElement) cartProductElement.dataset.note = textValue;
  }

  removeProductFromCartById(id) {
    const cartProduct = Array.from(this.querySelectorAll(`.addon-section--cart .addon-section__cart--product`)).find(el => el.dataset.id === id);
    if(cartProduct && cartProduct.dataset.price && !cartProduct.classList.contains("hidden")) {
      this.totalCalculator.decrease(parseFloat(cartProduct.dataset.price));
      cartProduct.classList.add("hidden");
      cartProduct.removeAttribute("data-id");
      cartProduct.removeAttribute("data-price");
    }
  }

  addProductToCart(tab, product, note) {
    const cartProduct = this.querySelector(`.addon-section--cart .addon-section__cart--product[data-index="${tab.dataset.index}"]`);
    if(!cartProduct) return;

    if(note) cartProduct.dataset.note = note;
    
    const newPrice = product.dataset.price;
    cartProduct.dataset.id = product.querySelector("input").value;
    cartProduct.dataset.price = newPrice;
    
    cartProduct.classList.remove("hidden");
    this.totalCalculator.increase(parseFloat(newPrice));
  }

  getSelectedDeliveryDate() {
    const selectedDate = this.querySelector(
      ".date-slider--block.is-selected, .date-slider--block.rao-is-selected, .date-slider--block.selected"
    ) || document.querySelector("rao-date-picker .rao-date-picker--day-name.selected");
    const dateValue = selectedDate?.dataset?.date || localStorage.getItem("date");
    return /^\d{4}-\d{2}-\d{2}$/.test(dateValue || "") ? dateValue : undefined;
  }

  getDeliveryLeadDays() {
    const match = this.getSelectedDeliveryDate()?.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return undefined;
    const today = new Date();
    const selectedUtc = Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    const todayUtc = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    const leadDays = Math.round((selectedUtc - todayUtc) / 86400000);
    return Number.isInteger(leadDays) && leadDays >= 0 && leadDays <= 365
      ? leadDays
      : undefined;
  }




  async addToCart() {
    if (this.isCartSubmitting) return;
    const checkoutButton = this.querySelector(".addon-section--add-to-cart");
    this.isCartSubmitting = true;
    checkoutButton?.classList.add("animate");
    const data = {items: []};
    const cartProducts = this.cart.querySelectorAll(".addon-section__cart--product[data-id]");
    const uid = new Date().valueOf();
    const configInstanceId = this.analytics.readRun()?.config_instance_id;
    const componentByIndex = {"0": "card", "1": "weight", "2": "gift"};
    const selectedDeliveryDate = this.getSelectedDeliveryDate();
    const deliveryLeadDays = this.getDeliveryLeadDays();
    const eventFields = {
      ...(deliveryLeadDays === undefined ? {} : { delivery_lead_days: deliveryLeadDays }),
      delivery_selection_source: this.deliverySelectionSource,
      item_count: cartProducts.length,
      card_selected: Boolean(this.cart.querySelector('.addon-section__cart--product[data-index="0"][data-id]')),
      weight_selected: Boolean(this.cart.querySelector('.addon-section__cart--product[data-index="1"][data-id]')),
      gift_selected: Boolean(this.cart.querySelector('.addon-section__cart--product[data-index="2"][data-id]')),
      has_message: Boolean(this.cart.querySelector('.addon-section__cart--product[data-note]')?.dataset.note?.trim())
    };

    this.completeCurrentStep("selected", {
      ...(deliveryLeadDays === undefined ? {} : { delivery_lead_days: deliveryLeadDays }),
      delivery_selection_source: this.deliverySelectionSource
    });
    this.analytics.emit("configurator_cart_submit", eventFields);


    for(let i = cartProducts.length - 1; i >= 0; i--) {
      const cartProduct = cartProducts[i];
      const component = cartProduct.classList.contains("addon-section__cart--product-main")
        ? "balloon"
        : componentByIndex[cartProduct.dataset.index];
      const properties = {_uid: uid};
      if (configInstanceId) {
        properties["_cfg"] = configInstanceId;
        if (component) properties["_cfgc"] = component;
      }
      const item = {id: cartProduct.dataset.id, quantity: 1, properties};
      if(cartProduct.dataset.note) {
        item.properties["Persoonlijk bericht"] = cartProduct.dataset.note;
      }
      if(component === "balloon") {
        item.properties["_main"] = true;

        const cartNote = document.querySelector('[name="note"]');
        if (cartNote && cartNote.value) item.properties["_Note"] = cartNote.value;
      } else {
        item.properties["_addon"] = true;
      }
      
      data.items.push(item);
    }

    try {
      if (selectedDeliveryDate) {
        localStorage.setItem("date", selectedDeliveryDate);
        localStorage.setItem("last_chosen_date", selectedDeliveryDate);

        const deliveryDateResponse = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: { "Bezorgdatum": selectedDeliveryDate } })
        });
        if (!deliveryDateResponse.ok) {
          const httpError = new Error("delivery_date_http_error");
          httpError.analyticsType = "http";
          httpError.analyticsStage = "delivery_date_update";
          httpError.httpStatus = deliveryDateResponse.status;
          throw httpError;
        }
      }

      const cartResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });
      if (!cartResponse.ok) {
        const httpError = new Error("cart_http_error");
        httpError.analyticsType = "http";
        httpError.httpStatus = cartResponse.status;
        throw httpError;
      }
      let cartResult;
      try {
        cartResult = await cartResponse.json();
      } catch (_) {
        const invalidResponseError = new Error("cart_invalid_json");
        invalidResponseError.analyticsType = "invalid_response";
        throw invalidResponseError;
      }
      if (!cartResult || !Array.isArray(cartResult.items)) {
        const invalidResponseError = new Error("cart_items_missing");
        invalidResponseError.analyticsType = "invalid_response";
        throw invalidResponseError;
      }
      this.analytics.emit("configurator_cart_success", eventFields);
      this.saveConfiguratorReturnState(selectedDeliveryDate);
      this.analytics.clearRun();
      document.location.href = "/cart";
    } catch(error) {
      const errorType = ["http", "network", "invalid_response"].includes(error?.analyticsType)
        ? error.analyticsType
        : "network";
      this.analytics.emit("configurator_cart_error", {
        error_stage: error?.analyticsStage || "cart_add",
        error_type: errorType,
        ...(Number.isInteger(error?.httpStatus) ? { http_status: error.httpStatus } : {})
      });
      this.isCartSubmitting = false;
      checkoutButton?.classList.remove("animate");
    }
  }
}
customElements.define('addon-section', AddonSection);

const restoreRaoConfiguratorAfterCartBack = (event) => {
  const navigationType = performance.getEntriesByType?.("navigation")?.[0]?.type;
  const isHistoryReturn = event?.persisted === true || navigationType === "back_forward";
  if (!isHistoryReturn || typeof window.history.state?.step === "undefined") return;

  const returnState = readRaoConfiguratorReturnState();
  if (!returnState) return;

  const existingConfigurator = document.querySelector("addon-section");
  if (existingConfigurator) {
    existingConfigurator.resetCartSubmitState?.();
    removeRaoConfiguratorReturnState();
    return;
  }

  if (window.__raoConfiguratorRestoreLoading) return;
  const trigger = document.querySelector(
    'rao-addon-trigger[data-filled="true"][data-add-to-cart="true"]'
  );
  if (!trigger) {
    removeRaoConfiguratorReturnState();
    return;
  }

  const historyStep = Number(window.history.state.step);
  window.__raoConfiguratorRestoreState = {
    ...returnState,
    step: Number.isInteger(historyStep) ? historyStep : returnState.step,
    textActive: window.history.state.textActive === true
  };
  window.__raoConfiguratorRestoreLoading = true;
  trigger.click();
};

restoreRaoConfiguratorAfterCartBack();
window.addEventListener("pageshow", restoreRaoConfiguratorAfterCartBack);

window.addEventListener('DOMContentLoaded', function() {
  /*const productCards = document.querySelectorAll('.rao-product-card');
  for(const productCard of productCards) {
    const quickBuy = productCard.querySelector('.product-card__quick-buy');

    if(quickBuy) {
      productCard.addEventListener('click', function(e) {
        if(quickBuy.contains(e.target)) {
          e.preventDefault();
          quickBuy.querySelector('form')._onSubmit(new SubmitEvent("submit", {submitter: quickBuy.querySelector('form')}));
        }
      });
    }
  }*/

  
  /* Product Page cheat */
  /*const addonContainer = document.querySelector('.product-info--extra-products');
  if(addonContainer) {
    if(window.innerWidth < 699) {
      addonContainer.style.setProperty('--width', `${window.innerWidth - 32}px`);
    }

    window.addEventListener('resize', function() {
      if(window.innerWidth < 699) {
        addonContainer.style.setProperty('--width', `${window.innerWidth - 32}px`);
      }
    });
  }*/
  
  /* Sticky add to cart filled balloons popup */
  /*if(document.querySelectorAll('.product-info__extra-products--item').length != 0) {
    const stickyButtons = document.querySelectorAll('.product-quick-buy--right-side button');
  
    for(const stickyButton of stickyButtons) {
      stickyButton.addEventListener('click', function(e) {
        if(document.querySelectorAll('.product-info__extra-products--item.checked').length == 0) {
          const form = document.querySelector(`form#${stickyButton.getAttribute('form')}`);
          form.classList.add('quick-buy--met-helium');
        }
      });
    }
  }

  const addToCartButtons = document.querySelectorAll('.product-info__block-item[data-block-type="buy-buttons"] button');

  for(const addToCartButton of addToCartButtons) {
    addToCartButton.addEventListener('click', function(e) {
      const form = addToCartButton.closest('form');
      form.classList.remove('quick-buy--met-helium');
    });
  }*/
  
  /* Filled balloons popup */
  const balloonButton = document.querySelector('.product--filled-balloon-button');
  const balloonPopup = document.querySelector('.product__filled-balloon-button--popup');

  if(balloonButton && balloonPopup) {
    const balloonContainer = balloonPopup.querySelector('.product__filled-balloon-button--popup-container');
    const balloonClose = balloonContainer.querySelector('svg');
    
    balloonButton.addEventListener('click', function() {
      balloonPopup.classList.add('open');
      document.documentElement.classList.add('lock');
    });

    balloonPopup.addEventListener('click', function(e) {
      if(!balloonContainer.contains(e.target)) {
        balloonPopup.classList.remove('open');
        document.documentElement.classList.remove('lock');
      }
    });

    balloonClose.addEventListener('click', function(e) {
      balloonPopup.classList.remove('open');
      document.documentElement.classList.remove('lock');
    });
  }
});

/* Infinite Collection */
class RAOCollection extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    if(typeof this.dataset.infiniteLoading != "undefined") {
      this.setupGlobals();
      this.triggers();
    }

    this.checkUSPs()
  }
  
  disconnectedCallback() {
    window.removeEventListener('scroll', this.bs);
  }

  checkUSPs() {
    const usps = this.querySelectorAll(".cllection-usp-container");
    const lastProduct = this.querySelector("product-list").lastElementChild;

    for(const usp of usps) {
      console.log(usp.getBoundingClientRect().top, lastProduct.getBoundingClientRect().bottom);
      if(usp.getBoundingClientRect().top > lastProduct.getBoundingClientRect().bottom) {
        usp.classList.add("cllection-usp-container-hide");
      } else {
        usp.classList.remove("cllection-usp-container-hide");
      }
    }
  }

  async asd() {
    if(this.prevPos == null) {
      this.prevPos = window.scrollY;
    }
    
    if(window.scrollY > this.prevPos) {
      // scrolling down
      if(!this.nextPagesLoaded) {
        if(this.getBoundingClientRect().bottom < window.innerHeight && !this.loading) {
          this.loading = true;
          this.bottomLoad.classList.add('show');
          await this.getNextPage();
          this.loading = false;
          setTimeout(function(){}, 1000);
          this.bottomLoad.classList.remove('show');
        }
      }
      
      this.prevPos = window.scrollY;
      if(this.lastCards[this.currentPage - 1] && !this.loading) {
        const card = this.lastCards[this.currentPage - 1];
        if(card.getBoundingClientRect().top + card.getBoundingClientRect().height * 1.5 < window.innerHeight && card.getBoundingClientRect().top + card.getBoundingClientRect().height * 1.5 > 0) {
          if(this.currentPage + 1 <= this.lastCards.length) {
            this.currentPage += 1;
            this.searchParams.set("page", this.currentPage);
            this.searchParams.delete("section_id");
            window.history.replaceState({}, "", this.url);
          }
        }
      }
    }
    if(window.scrollY < this.prevPos) {
      // scrolling up
      if(!this.prevPagesLoaded && this.currentPage > 1) {
        if(this.getBoundingClientRect().top > -62 && !this.loading) {
          this.loading = true;
          this.topLoad.classList.add('show');
          await this.getPrevPage();
          this.loading = false;
          setTimeout(function(){}, 1000);
          this.topLoad.classList.remove('show');
        }
      }

      this.prevPos = window.scrollY;
      if(this.currentPage > 1 && !this.loading) {
        const card = this.lastCards[this.currentPage - 2];
        if(card) {
          if(card.getBoundingClientRect().top + card.getBoundingClientRect().height * 1.5 > window.innerHeight) {
            this.currentPage -= 1;
            this.searchParams.set("page", this.currentPage);
            this.searchParams.delete("section_id");
            window.history.replaceState({}, "", this.url);
          }
        }
      }
    }
  }

  triggers() {
    this.bs = this.asd.bind(this);
    this.prevPos = null;
    window.addEventListener('scroll', this.bs);
  }

  getLastCards() {
    console.log(this.lastCards);
  }

  setupGlobals() {
    this.sectionId = this.closest('section').id.replace('shopify-section-', '');
    this.productList = this.querySelector('product-list');

    this.topLoad = this.querySelector('.rao-collection--load-more-top');
    this.bottomLoad = this.querySelector('.rao-collection--load-more-bottom');
    
    this.url = new URL(window.location.href);
    this.searchParams = this.url.searchParams;
    this.currentPage = 1;                                                    // Page content what the user sees, changes based on scroll.
    if(this.searchParams.has("page")) {
      this.currentPage = parseInt(this.searchParams.get("page"));
    }

    this.lastCards = [];
    this.lastCards[this.currentPage - 1] = this.productList.children[this.productList.children.length - 1];

    this.prevPagesLoaded = false;
    if(this.currentPage == 1) {
      this.prevPagesLoaded = true;
    }
    this.nextPagesLoaded = false;
  }

  async getPrevPage() {
    const scrollPos = window.scrollY;
    this.searchParams.set("page", this.currentPage - 1);
    this.searchParams.set("section_id", this.sectionId);
    
    const htmlTemp = await (await fetch(this.url, {
      method: "GET",
      headers: {
        "Content-Type": "text/html"
      }
    })).text();

    const html = document.implementation.createHTMLDocument("asd");
    html.body.innerHTML = htmlTemp;

    const newProductCardsContainer = html.querySelector('product-list');
    
    let lastCard;
    for(let i = newProductCardsContainer.children.length - 1; i >= 0; i--) {
      this.productList.prepend(newProductCardsContainer.children[i].cloneNode(true));
    }

    this.lastCards[this.currentPage - 2] = this.productList.children[newProductCardsContainer.children.length - 1];
    this.lastCards[this.currentPage - 2].scrollIntoView();
    
    this.currentPage -= 1;
    this.searchParams.set("page", this.currentPage);

    this.searchParams.delete("section_id");
    window.history.replaceState({}, "", this.url);

    if(this.currentPage == 1) {
      this.prevPagesLoaded = true;
    }

    this.checkUSPs()
  }

  async getNextPage() {
    this.searchParams.set("page", this.currentPage + 1);
    this.searchParams.set("section_id", this.sectionId);
    
    const htmlTemp = await (await fetch(this.url, {
      method: "GET",
      headers: {
        "Content-Type": "text/html"
      }
    })).text();

    const html = document.implementation.createHTMLDocument("asd");
    html.body.innerHTML = htmlTemp;


    const newProductCardsContainer = html.querySelector('product-list');
    const newProductItems = newProductCardsContainer ? Array.from(newProductCardsContainer.children) : [];

    if(newProductItems.length == 0) {
      this.nextPagesLoaded = true;
    }

    if(newProductItems.length != 0) {
      let appendedLastCard = null;

      for(const newItem of newProductItems) {
        appendedLastCard = this.productList.appendChild(newItem.cloneNode(true));
      }

      this.lastCards.push(appendedLastCard);
      this.currentPage += 1;
      this.searchParams.set("page", this.currentPage);

      this.searchParams.delete("section_id");
      window.history.replaceState({}, "", this.url);
    }

    this.checkUSPs()
  }
}

customElements.define('rao-collection', RAOCollection);

/* RAO Calendar */
class RAOCalendar {
  #monthNames = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];
  #monthLastDays = [31, 30, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  #longDayNames = ["Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag", "Zondag"];
  #blacklistedDates = [];
  #currentDate = new Date();

  constructor(blacklistedDates) {
    this.shortDayNames =  ["Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"];
    if(blacklistedDates) {
      this.#blacklistedDates = blacklistedDates.split(",");
    }
  }

  getMonthName(index) {
    return this.#monthNames[index]
  }

  getMonth(year, month) {
    const date = new Date(`${year}-${month.toString().padStart(2, "0")}-01`);
    const monthObj = {
      month: month,
      monthName: this.#monthNames[month-1],
      year: year,
      days: []
    }

    for(let i = 0; i < this.#monthLastDays[month-1]; i++) {
      const newDate = new Date(date);
      monthObj.days.push(this.getDay(newDate));
      date.setDate(date.getDate() + 1);
      if(date.getMonth() != month-1) {
        break
      }
    }

    return monthObj
  }

  getDay(date) {
    const dayObj = {
      date: date,
      dayNumber: this.#getDayNumber(date.getDay()),
      shortDayName: this.shortDayNames[this.#getDayNumber(date.getDay())],
      longDayName: this.#longDayNames[this.#getDayNumber(date.getDay())],
      available: this.#isDateAvailable(date)
    };

    return dayObj
  }

  getNextAvailableDay(date) {
    while(true) {
      date.setHours(24)
      if(this.#isDateAvailable(date)) {
        return this.getDay(date)
      }
    }
  }

  #isDateAvailable(date) {
    const now = new Date(this.#currentDate);
    if(this.#isDateToday(date)) {
      return false
    } else if(this.#isDateInThePast(date)) {
      return false
    } else if(date.getDay() == 0) {
      return false
    } else if(now.getHours() > 22 || (now.getHours() == 22 && now.getMinutes() >= 30)) {
      const tomorrow = new Date(now);
      tomorrow.setDate(now.getDate() + 1);

      const isTomorrow = date.getFullYear() == tomorrow.getFullYear() && date.getMonth() == tomorrow.getMonth() && date.getDate() == tomorrow.getDate();

      if(isTomorrow) {
        return false
      }
    } else if(this.#isDateBlacklisted(date)) {
      return false
    } else if(this.#cleanDate(date).getTime() - new Date(this.#currentDate).getTime() == 86400000 && new Date(this.#currentDate).getDay() == 5) {
      //return false
    }

    return true
  }

  #isDateToday(dateTemp) {
    const today = new Date(this.#currentDate);
    const date = this.#cleanDate(dateTemp);

    if(date.getTime() == today.getTime()) {
      return true
    }
    return false
  }

  #isDateInThePast(dateTemp) {
    const today = new Date(this.#currentDate);
    const date = this.#cleanDate(dateTemp);

    if(date.getTime() < today.getTime()) {
      return true
    }

    return false
  }

  #isDateBlacklisted(date) {
    return this.#blacklistedDates.includes(`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${(date.getDate()).toString().padStart(2, "0")}`);
  }

  #cleanDate(dateTemp) {
    const date = new Date(this.#currentDate);

    date.setFullYear(dateTemp.getFullYear());
    date.setMonth(dateTemp.getMonth());
    date.setDate(dateTemp.getDate());

    return date
  }

  #getDayNumber(dayNumber) {
    if(dayNumber == 0) {
      return 6
    }
    return dayNumber - 1
  }
}

/* Date Picker Btn */
class RAODatePickerBtn extends HTMLElement {
  constructor() {
    super();

    if(this.dataset.showSelected == "true") {
      this.addEventListener("date-picker:change", (e) => this.#dayChangeEvent(e));
    }
  }

  connectedCallback() {
    const datePicker = document.querySelector("rao-date-picker");
    this.addEventListener("click", function() {
      datePicker.open();
    });
  }

  #dayChangeEvent(e) {
    this.classList.add("show-selected");
    if(this.querySelector(".rao-date-picker--selected-title-long")) {
      this.querySelector(".rao-date-picker--selected-title-long").innerText = e.detail.longDate;
      const titleShort = e.detail.date.split("-");
      this.querySelector(".rao-date-picker--selected-title-short").innerText = `${titleShort[2]}-${titleShort[1]}-${titleShort[0]}`;
    } else {
      this.querySelector(".rao-date-picker--selected-title").innerText = e.detail.longDate;
    }
  }
}

customElements.define("rao-date-picker-btn", RAODatePickerBtn);

/* Date Picker */
class RAODatePicker extends HTMLElement {
  #calendar = new RAOCalendar(this.dataset.blacklistedDates);
  #currDate = new Date();
  #monthBlockIndex = 0;
  #tabsAmount;

  constructor() {
    super();
    this.overlay = this.querySelector(".rao-date-picker--overlay");
    this.container = this.querySelector(".rao-date-picker--container");
    this.addEventListener("date-picker:change", (e) => this.#dayChangeEvent(e));

    window.addEventListener("scroll", function() {
      this.container.style.setProperty("--top-amount", `${this.getBoundingClientRect().bottom}px`);
    }.bind(this));

    this.overlay.addEventListener("click", this.close.bind(this));

    /*window.addEventListener("click", function(e) {
      if(!this.contains(e.target) && !e.target.classList.contains("rao-date-picker--titles") && !e.target.classList.contains("rao-date-picker--default-title") && !e.target.classList.contains("rao-date-picker--selected-title")) {
        this.close();
      }
    }.bind(this));*/

    this.nextBtn = this.querySelector(".rao-date-picker--next");
    this.prevBtn = this.querySelector(".rao-date-picker--previous");

    this.nextBtn.addEventListener("click", this.nextMonth.bind(this));
    this.prevBtn.addEventListener("click", this.prevMonth.bind(this));
  }

  connectedCallback() {
    this.#parseMonths();

    this.#tabsAmount = this.querySelectorAll(".rao-date-picker--block").length;
    this.#defaultSelect();
  }

  open() {
    this.overlay.classList.add("open");
    const topAmount = this.getBoundingClientRect().bottom;
    this.container.style.setProperty("--top-amount", `${topAmount}px`);
    this.container.classList.add("open");
  }

  close() {
    this.overlay.classList.remove("open");
    this.container.classList.remove("open");
  }

  nextMonth() {
    if(!this.nextBtn.classList.contains("disabled")) {
      this.#monthBlockIndex++;
      this.container.style.setProperty("--transform-amount", `${-1 * this.#monthBlockIndex * 100}%`);
      
      this.prevBtn.classList.remove("disabled");
      if(this.#monthBlockIndex == this.#tabsAmount - 2) {
        this.nextBtn.classList.add("disabled");
      }
    }
  }

  prevMonth() {
    if(!this.prevBtn.classList.contains("disabled")) {
      this.#monthBlockIndex--;
      this.container.style.setProperty("--transform-amount", `${-1 * this.#monthBlockIndex * 100}%`);

      this.nextBtn.classList.remove("disabled");
      if(this.#monthBlockIndex == 0) {
        this.prevBtn.classList.add("disabled");
      }
    }
  }

  selectMonth(index) {
    this.#monthBlockIndex = index;
    this.container.style.setProperty("--transform-amount", `${-1 * this.#monthBlockIndex * 100}%`);

    if(this.#monthBlockIndex == 0) {
      this.prevBtn.classList.add("disabled");
    } else {
      this.prevBtn.classList.remove("disabled");
    }

    if(this.#monthBlockIndex == this.#tabsAmount - 2) {
      this.nextBtn.classList.add("disabled");
    } else {
      this.nextBtn.classList.remove("disabled");
    }
  }

  #parseMonths() {
    let month = this.#currDate.getMonth() + 1;
    let year = this.#currDate.getFullYear();
    for(let i = 0; i < 12; i++) {
      this.#parseMonth(year, month);
      month++;
      if(month > 12) {
        year++;
        month = 1;
      }
    }
  }

  #parseMonth(year, month) {
    const monthObj = this.#calendar.getMonth(year, month);

    const monthElement = document.createElement("div");
    monthElement.classList.add("rao-date-picker--block");

    this.#parseDefaultMonthContent(monthObj, monthElement);
    this.#parseDays(monthObj, monthElement);
    

    this.container.appendChild(monthElement);
  }

  #parseDays(monthObj, monthElement) {
    const monthDaysElement = monthElement.querySelector(".rao-date-picker--days");

    this.#parseEmptyDays(monthObj, monthDaysElement);

    for(const day of monthObj.days) {
      const monthDay = document.createElement("span");
      
      monthDay.classList.add("rao-date-picker--day-name");
      if(!day.available) {
        monthDay.classList.add("no-hover", "disabled");
      }

      monthDay.dataset.date = `${day.date.getFullYear()}-${(day.date.getMonth() + 1).toString().padStart(2, "0")}-${(day.date.getDate()).toString().padStart(2, "0")}`;
      monthDay.innerText = day.date.getDate();

      monthDay.addEventListener("click", this.#dayClickHandle.bind(this, monthDay.dataset.date));

      monthDaysElement.appendChild(monthDay);
    }
  }

  #dayClickHandle(date) {
    const day = this.#calendar.getDay(new Date(date));
    const datePickers = document.querySelectorAll("rao-date-picker");
    const dateSliders = document.querySelectorAll("rao-date-slider");
    const dateBtns = document.querySelectorAll("rao-date-picker-btn");
    for(const datePicker of datePickers) {
      datePicker.dispatchEvent(new CustomEvent("date-picker:change", {detail: {date: date}}));
    }
    for(const dateSlider of dateSliders) {
      dateSlider.dispatchEvent(new CustomEvent("date-picker:change", {detail: {date: date}}));
    }
    for(const dateBtn of dateBtns) {
      dateBtn.dispatchEvent(new CustomEvent("date-picker:change", {detail: {date: date, longDate: `${day.longDayName} ${day.date.getDate()} ${this.#calendar.getMonthName(day.date.getMonth())}`}}));
    }
    localStorage.setItem("date", date);
  }

  #dayChangeEvent(event) {
    const chosenDate = this.querySelector(`.rao-date-picker--day-name[data-date="${event.detail.date}"]`);
    if(!chosenDate.classList.contains("disabled")) {
      const selectedDay = this.querySelector(".rao-date-picker--day-name.selected");
      if(selectedDay) {
        selectedDay.classList.remove("selected");
      }

      chosenDate.classList.add("selected");
      this.close();

      const chosenMonth = chosenDate.closest(".rao-date-picker--block");
      this.selectMonth(this.#getMonthIndex(chosenMonth));

      if(this.dataset.dateFormat == "true") {
        /*const day = this.#calendar.getDay(new Date(event.detail.date));
        this.querySelector(".rao-date-picker--titles").classList.add("show-selected");
        this.querySelector(".rao-date-picker--selected-title").innerText = `${day.longDayName} ${day.date.getDate()} ${this.#calendar.getMonthName(day.date.getMonth())}`;*/
      }
    }
  }

  #defaultSelect() {
    const selectedDate = localStorage.getItem("date");
    if(selectedDate) {
      const date = new Date(selectedDate);
      if(date) {
        const day = this.#calendar.getDay(date);
        if(day.available) {
          this.#dayClickHandle(selectedDate);
        } else {
          const nextAvailableDate = this.#calendar.getNextAvailableDay(date);
          this.#dayClickHandle(`${day.date.getFullYear()}-${(day.date.getMonth() + 1).toString().padStart(2, "0")}-${(day.date.getDate()).toString().padStart(2, "0")}`);
        }
      }
    }
  }

  #parseDefaultMonthContent(monthObj, monthElement) {
    const monthName = document.createElement("p");
    monthName.classList.add("rao-date-picker--month");
    monthName.innerText = monthObj.monthName;
    monthElement.appendChild(monthName);

    const monthDays = document.createElement("div");
    monthDays.classList.add("rao-date-picker--days");
    monthElement.appendChild(monthDays);

    for(let i = 0; i < 7; i++) {
      const monthDay = document.createElement("span");
      monthDay.classList.add("rao-date-picker--day-name", "no-hover");
      monthDay.innerText = this.#calendar.shortDayNames[i];
      monthDays.appendChild(monthDay);
    }
  }

  #parseEmptyDays(monthObj, monthDaysElement) {
    for(let i = 0; i < monthObj.days[0].dayNumber; i++) {
      const monthDay = document.createElement("span");
      monthDay.classList.add("rao-date-picker--day-name", "no-hover");
      monthDaysElement.appendChild(monthDay);
    }
  }

  #getMonthIndex(chosenMonthElement) {
    const monthElements = this.container.querySelectorAll(".rao-date-picker--block");
    for(let i = 0; i < monthElements.length; i++) {
      if(monthElements[i] == chosenMonthElement) {
        return i
      }
    }
  }
}

customElements.define('rao-date-picker', RAODatePicker);

class TooltipInfo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const tooltipButton = this.querySelector('svg');
    const tooltipText = this.querySelector('.product-info__extra-products--tooltip-info');
    const headerHeight = document.querySelector('header').getBoundingClientRect().height + document.querySelector('.shopify-section--announcement-bar').getBoundingClientRect().height;

    this.positionContent(tooltipText, headerHeight);
    
    tooltipButton.addEventListener('click', function() {
      tooltipText.classList.add('open');
    });

    window.addEventListener('scroll', function() {
      if(!tooltipText.classList.contains('open')) {
        this.positionContent(tooltipText, headerHeight);
      }
    }.bind(this));
    
    window.addEventListener('click', function(e) {
      if(tooltipText.classList.contains('open')) {
        if(!(this.contains(e.target))) {
          tooltipText.classList.remove('open');
        }
      }
    }.bind(this));
  }

  positionContent(tooltipText, headerHeight) {
    const textInfo = tooltipText.getBoundingClientRect();

    if(this.getBoundingClientRect().top - headerHeight < textInfo.height) {
      tooltipText.classList.add('bottom');
    } else {
      tooltipText.classList.remove('bottom');
    }
  }
}

customElements.define('tooltip-info', TooltipInfo);

class TooltipInfoExtra extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const parentContainer = this.closest('.floating-controls-container');
    const content = this.querySelector('.tooltip-info-extra--content');
    this.parentContent = null;

    this.addEventListener('click', function() {
      this.showContent(parentContainer, content);
    }.bind(this));

    window.addEventListener('click', function(e) {
      if(this.parentContent && this.parentContent.classList.contains('open')) {
        if(!this.contains(e.target) && !this.parentContent.contains(e.target)) {
          this.parentContent.classList.remove('open');
        }
      }
    }.bind(this));
  }

  showContent(parentContainer, content) {
    const copyContent = content.cloneNode(true);
    if(!this.parentContent) {
      parentContainer.appendChild(copyContent);
      this.parentContent = copyContent;
    } else {
      this.parentContent.innerHTML = copyContent.innerHTML;
    }

    const top = this.getBoundingClientRect().top - parentContainer.getBoundingClientRect().top + this.getBoundingClientRect().height;
    this.parentContent.style.setProperty('--top-amount', `${top}px`);

    const left = this.getBoundingClientRect().left - parentContainer.getBoundingClientRect().left;
    let widthMinus = 0;
    if(left > 20) {
      this.parentContent.style.setProperty('--left-amount', "20px");
      widthMinus -= 20;
    }
    if(left < parentContainer.getBoundingClientRect().width - 20) {
      widthMinus -= 20;
    }

    this.parentContent.style.setProperty('--width-amount', `calc(100% + ${widthMinus}px)`);
    this.parentContent.style.setProperty('--point-left-amount', `${left}px`);

    this.parentContent.classList.add('open');
  }
}

customElements.define('tooltip-info-extra', TooltipInfoExtra);

class ExtraProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if(window.innerWidth < 699) {
      this.style.setProperty('--width', `${window.innerWidth - 32}px`);
    }

    window.addEventListener('resize', function() {
      if(window.innerWidth < 699) {
        this.style.setProperty('--width', `${window.innerWidth - 32}px`);
      }
    }. bind(this));
    
    const extraProductButtons = this.querySelectorAll('.product-info__extra-products--button');
    const popupInfoContainer = document.querySelector('.product-info__popup-info--container');

    if(popupInfoContainer) {
      const extraAddonProductButtons = this.querySelectorAll('.product-addons__extra-products--add-button');
      const extraAddonProductRemoveButtons = this.querySelectorAll('.product-addons__extra-products--remove-button span');
      const popupOverlay = document.querySelector('.product-info__popup-info--overlay');
      const popupContainer = document.querySelector('.product-info--popup-info');
      const closeButton = popupContainer.querySelector('.product-info__popup-info--close');
      let scrollPos = 0;

      closeButton.addEventListener('click', function() {
        popupOverlay.classList.remove('open');
        document.documentElement.classList.remove('lock');
        window.scrollTo(0, scrollPos);
      });

      for(const extraAddonProductButton of extraAddonProductButtons) {
        extraAddonProductButton.addEventListener('click', function() {
          extraAddonProductButton.closest('.product-addons__extra-products--product').classList.add('checked');
        });
      }

      for(const extraAddonProductRemoveButton of extraAddonProductRemoveButtons) {
        extraAddonProductRemoveButton.addEventListener('click', function() {
          extraAddonProductRemoveButton.closest('.product-addons__extra-products--product').classList.remove('checked');
        });
      }

      for(const extraProductButton of extraProductButtons) {
        const mainContainer = extraProductButton.closest('.product-info__extra-products--item');
        const productTitle = mainContainer.querySelector('.product-info__extra-products--title span');
        const productImage = mainContainer.querySelector('.product-info__extra-products--image');
        const productPopupInfo = extraProductButton.querySelector('.product-info__extra-products--popup-info');
        
        const removeButton = mainContainer.querySelector('.product-info__extra-products--checkmark span');
        removeButton.addEventListener('click', function() {
          mainContainer.classList.remove('checked');
          mainContainer.querySelector(".product-info__extra-products--item-note").innerHTML = "";
          mainContainer.querySelector('.product-info__extra-products--image img:nth-child(2)').remove();
        });
  
        extraProductButton.addEventListener('click', function() {
          scrollPos = this.openAddonPopup(mainContainer, productPopupInfo, popupInfoContainer, popupContainer, popupOverlay);
        }.bind(this));
        productTitle.addEventListener('click', function() {
          if(!mainContainer.classList.contains('checked')) {
             scrollPos = this.openAddonPopup(mainContainer, productPopupInfo, popupInfoContainer, popupContainer, popupOverlay);
          }
        }.bind(this));
        productImage.addEventListener('click', function() {
          if(!mainContainer.classList.contains('checked')) {
             scrollPos = this.openAddonPopup(mainContainer, productPopupInfo, popupInfoContainer, popupContainer, popupOverlay);
          }
        }.bind(this));
      }
    }
  }

  openAddonPopup(mainContainer, productPopupInfo, popupInfoContainer, popupContainer, popupOverlay) {
    const scrollPos = window.scrollY;
    if(productPopupInfo) {
      /* Copy content to popup and open popup */
      popupInfoContainer.innerHTML = productPopupInfo.innerHTML;

      const input = popupInfoContainer.querySelector('.product-info__popup-info--textarea');
      if(input) {
        input.addEventListener('input', function() {
          input.scrollIntoView();
        });
      }
  
      const imageContainer = popupInfoContainer.querySelector('.product-info__popup-info--images');
      const images = popupInfoContainer.querySelectorAll('.product-info__popup-info--images img');
  
      if(images.length > 6) {
        imageContainer.style.maxHeight = `${images[0].getBoundingClientRect().height * 1.5 + 15}px`;
  
        window.addEventListener('resize', function() {
          imageContainer.style.maxHeight = `${images[0].getBoundingClientRect().height * 1.5 + 15}px`;
        });
      }
      
      const form = popupInfoContainer.querySelector('.product-info__popup-info--form');
  
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const formData = new FormData(form);
  
        mainContainer.querySelector('form').innerHTML = form.innerHTML;
        if(form.querySelector('[name="properties[Persoonlijk bericht]"]')) {
          mainContainer.querySelector('form [name="properties[Persoonlijk bericht]"]').value = form.querySelector('[name="properties[Persoonlijk bericht]"]').value;
        }
        
        mainContainer.classList.add('checked');
  
        const selectedImage = popupInfoContainer.querySelector('.product-info__popup-info--images img.selected');
        
        if(selectedImage) {
          const newImage = document.createElement('img');
          newImage.setAttribute('src', selectedImage.getAttribute('src').replace('"', ''));
          newImage.setAttribute('width', '900');
          newImage.setAttribute('height', '900');
          newImage.setAttribute('sizes', '100px');
          mainContainer.querySelector('.product-info__extra-products--image').appendChild(newImage);
        }
  
        if(formData.get("properties[Persoonlijk bericht]")) {
          mainContainer.querySelector('.product-info__extra-products--item-note').innerHTML = `<li>${formData.get("properties[Persoonlijk bericht]").replace('"', '').replace("\n", "<br>")}</li>`;
        }

        window.scrollTo(0, scrollPos);
        popupInfoContainer.closest('.product-info__popup-info--overlay').classList.remove('open');
        document.documentElement.classList.remove('lock');
      });
  
  
      for(const image of images) {
        image.addEventListener('click', function() {
          const prevImage =  popupInfoContainer.querySelector('.product-info__popup-info--images img.selected');
          if(prevImage) {
            prevImage.classList.remove('selected');
          }
  
          image.classList.add('selected');
          popupInfoContainer.querySelector('input[name="id"]').value = image.dataset.id;
        });
      }
      
      popupContainer.style.setProperty('--top-amount', (window.innerHeight - popupContainer.getBoundingClientRect().height) / 2 + "px");
      setTimeout(function() {
        popupOverlay.classList.add('open');
        document.documentElement.classList.add('lock');
      },100);
    }
  
    return scrollPos;
  }
}

customElements.define('extra-products', ExtraProducts);

window.addEventListener('DOMContentLoaded', function() {
  const announcementBars = document.querySelectorAll(".announcement-bar-custom-stack-wrapper");
  for(const announcementBar of announcementBars) {
    announcementBar.style.height = `${announcementBar.getBoundingClientRect().height}px`;
  }


  const extraProductsTemp = document.querySelector('.product-info__extra-products--temp');
  if(extraProductsTemp) {
    extraProductsTemp.addEventListener('click', function(e) {
      if(!extraProductsTemp.firstElementChild.contains(e.target)) {
        extraProductsTemp.firstElementChild.dispatchEvent(new CustomEvent("asd:add"));
      }
    });
  }

  const popupInfoOverlay = document.querySelector('.product-info__popup-info--overlay');
  popupInfoOverlay.addEventListener('click', function(e) {
    if(!popupInfoOverlay.firstElementChild.contains(e.target)) {
      popupInfoOverlay.classList.remove('open');
      document.documentElement.classList.remove('lock');
    }
  });
});

class RAODatePickerCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.container = this.querySelector('.rao-date-picker--container');
    this.blockTemp = this.container.querySelector('.rao-date-picker--block');
    this.blockTemp.remove();
    this.blacklistedDates = this.dataset.blacklistedDates.split(',');
    this.monthAmountShown = parseInt(this.dataset.monthAmountShown);
    this.monthNames = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"];
    this.monthLastDays = [31, 30, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    this.dayNames = ["Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"];

    this.createCalendar();
    this.setupEvents();
  }

  setupEvents() {
    const prevButton = this.querySelector('.rao-date-picker--previous');
    const nextButton = this.querySelector('.rao-date-picker--next');
    const inputPicker = this.querySelector('.rao-date-picker--input');
    const inputText = inputPicker.querySelector('.rao-date-picker__input--text');
    const dayItems = this.querySelectorAll('.rao-date-picker--day-name:not(.no-hover)');
    const input = this.querySelector('input');
    this.selectedDay = "";
    
    let currentSlide = 0;

    prevButton.addEventListener('click', function() {
      if(currentSlide != 0) {
        currentSlide--;
        this.container.style.setProperty("--transform-amount", `-${currentSlide * 100}%`);
        if(currentSlide == 0) {
          prevButton.classList.add('disabled');
        }
        nextButton.classList.remove('disabled');
      }
    }.bind(this));

    nextButton.addEventListener('click', function() {
      if(currentSlide != this.container.querySelectorAll('.rao-date-picker--block').length - 1) {
        currentSlide++;
        this.container.style.setProperty("--transform-amount", `-${currentSlide * 100}%`);
        if(currentSlide == this.container.querySelectorAll('.rao-date-picker--block').length - 1) {
          nextButton.classList.add('disabled');
        }
        prevButton.classList.remove('disabled');
      }
    }.bind(this));

    inputPicker.addEventListener('click', function() {
      this.container.classList.toggle('open');
    }.bind(this));

    window.addEventListener('click', function(e) {
      if(this.container.classList.contains('open')) {
        if(!this.contains(e.target)) {
          this.container.classList.remove('open');
        }
      }
    }.bind(this));

    for(const dayItem of dayItems) {
      dayItem.addEventListener('click', function() {
        if(dayItem.classList.contains('selected')) {
          dayItem.classList.remove('selected');
          this.selectedDay = "";
          inputText.innerText = inputText.dataset.placeholder;
          input.value = "";
        } else {
          if(this.selectedDay != "") {
            this.selectedDay.classList.remove('selected');
          }
          
          dayItem.classList.add('selected');
          this.container.classList.remove('open');
          inputText.innerText = dayItem.dataset.date;
          this.selectedDay = dayItem;
          input.value = dayItem.dataset.date;
        }
      }.bind(this));
    }
  }

  createCalendar() {
    this.currentDate = new Date();
    this.firstAvailableDate = new Date();
    this.firstAvailableDate.setHours(24);

    if(this.currentDate.getDay() == 5) {
      if(this.currentDate.getHours() >= 16) {
        this.firstAvailableDate.setHours(72);
      }
    } else if(this.currentDate.getDay() == 6) {
      this.firstAvailableDate.setHours(48);
    } else if(this.currentDate.getDay() == 0) {
      this.firstAvailableDate.setHours(24);
    } else if(this.currentDate.getHours() >= 16) {
      this.firstAvailableDate.setHours(24);
    }

    this.firstAvailableDate = new Date(this.firstAvailableDate);
    let currentMonthIndex = this.currentDate.getMonth();
    let currentYear = this.currentDate.getFullYear();
    
    for(let i = 0; i < this.monthAmountShown; i++) {
      const blockElement = this.blockTemp.cloneNode(true);
      const monthElement = blockElement.querySelector('.rao-date-picker--month');
      const daysContainer = blockElement.querySelector('.rao-date-picker--days');
      if(currentMonthIndex > 11) {
         currentMonthIndex = 0;
        currentYear++;
      }
      monthElement.innerText = this.monthNames[currentMonthIndex];

      this.parseDayNames(daysContainer);
      this.parseWeeks(daysContainer, 1, currentYear, currentMonthIndex);

      currentMonthIndex++;
      this.container.appendChild(blockElement);
    }
  }

  parseDayNames(daysContainer) {
    const weekElement = document.createElement('div');
    weekElement.classList.add('rao-date-picker--week');
    
    for(let i = 0; i < 7; i++) {
      const dayElement = document.createElement('span');
      dayElement.classList.add('rao-date-picker--day-name');
      dayElement.classList.add('no-hover');

      dayElement.innerText = this.dayNames[i];
      weekElement.appendChild(dayElement);
    }

    daysContainer.appendChild(weekElement);
  }

  parseWeeks(daysContainer, startingDay, year, monthIndex) {
    let monthIndexTemp = monthIndex;
    let monthLastDay = 28;

    if(monthIndex != 1) {
      monthLastDay = this.monthLastDays[monthIndex];
    } else {
      if(new Date(`${year}-${monthIndex + 1}-29`).getMonth() == monthIndex) {
        monthLastDay = 29;
      } else {
        monthLastDay = 28;
      }
    }

    if(startingDay <= monthLastDay) {
      let date = new Date(`${year}-${(monthIndex + 1).toString().padStart(2, "0")}-${startingDay.toString().padStart(2, "0")}`);
      const weekElement = document.createElement('div');
      weekElement.classList.add('rao-date-picker--week');
      let counter = 0;

      for(let i = 0; i < 7; i++) {
        if(parseInt(startingDay)+i > monthLastDay) {
          break;
        }
        
        const dayElement = document.createElement('span');
        dayElement.classList.add('rao-date-picker--day-name');

        let getDay = date.getDay();
        if(getDay == 0) {
          getDay = 7;
        }
        if(i + 1 == getDay) {
          if(this.blacklistedDates.includes(`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${(date.getDate()).toString().padStart(2, "0")}`)) {
            dayElement.classList.add('no-hover');
            dayElement.classList.add('disabled');
          }

          if(date < this.firstAvailableDate) {
            dayElement.classList.add('no-hover');
            dayElement.classList.add('disabled');
          }

          dayElement.innerText = date.getDate();
          dayElement.dataset.date = `${(date.getDate()).toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
          date.setDate(date.getDate() + 1);
          counter++;
        } else {
          dayElement.classList.add('no-hover');
        }

        weekElement.appendChild(dayElement);
      }

      daysContainer.appendChild(weekElement);
      if(parseInt(startingDay)+counter <= monthLastDay) {
        this.parseWeeks(daysContainer, parseInt(startingDay)+counter, date.getFullYear(), date.getMonth());
      }
    }
  }
}

customElements.define('rao-date-picker-cart', RAODatePickerCart);

class CartItem {
  constructor() {
    this.main = {found: false, quantity: 0};
    this.addons = [];
  }

  add(obj) {
    if(obj.main) {
      this.main.found = true;
      this.main.quantity = obj.quantity;
    } else {
      this.addons.push({key: obj.key, quantity: obj.quantity});
    }
  }
}

window.addEventListener("load", async function() {
  const cart = await(await fetch("https://www.ballonnenshop.nl/cart.js")).json();
  const idMap = new Map();

  for(const item of cart.items) {
    if(item.properties._uid) {
      const itemTemp = {
        main: typeof item.properties._main !== "undefined" ? true : false, /* boolean assigning is redundant, but keeping it for the sake of easy differentiation */
        quantity: item.quantity,
        key: item.key
      };

      if(!idMap.has(item.properties._uid)) {
        idMap.set(item.properties._uid, new CartItem());
      }

      idMap.get(item.properties._uid).add(itemTemp);
    }
  }

  for([key, value] of idMap) {
    const mainQuantity = value.main.quantity;

    for(const obj of value.addons) {
      if(obj.quantity != mainQuantity) {
        fetch("https://www.ballonnenshop.nl/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ id: obj.key, quantity: mainQuantity })
        });
        document.dispatchEvent(new CustomEvent("cart:refresh", {})); 
      }
    }
  }
});
